/* eslint-disable max-len */
import * as React from "react";
import { registerIcons } from "@fluentui/react";

const HomeSolid = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <defs>
      <linearGradient id="a" x1="9" y1="17.66" x2="9" y2=".34" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset=".17" stopColor="#1c84dc" />
        <stop offset=".38" stopColor="#3990e4" />
        <stop offset=".59" stopColor="#4d99ea" />
        <stop offset=".8" stopColor="#5a9eee" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
    </defs>
    <path d="M17.8 8.29L9.41.5a.61.61 0 00-.82 0L.2 8.29a.62.62 0 00.47 1.06h1.72a.3.3 0 01.3.3v7.4a.61.61 0 00.61.61h11.4a.61.61 0 00.61-.61v-7.4a.3.3 0 01.3-.3h1.72a.62.62 0 00.47-1.06z" fill="#0078d4" />
    <path d="M7.07 12.4h3.86a.36.36 0 01.32.38v4.88h-4.5v-4.88a.36.36 0 01.32-.38z" fill="#e6e6e6" />
    <path d="M.67 9.35h.53l7.39-6.86a.61.61 0 01.82 0l7.39 6.86h.53a.62.62 0 00.47-1.06L9.41.5a.61.61 0 00-.82 0L.2 8.29a.62.62 0 00.47 1.06z" fill="#005ba1" />
  </svg>
);

const ResourceGroup = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <path d="M.5 15.08a.16.16 0 00.08.14l1.16.65L3.7 17a.17.17 0 00.23-.06l.66-1.12a.16.16 0 00-.06-.21l-2.3-1.3a.17.17 0 01-.08-.14V3.85a.16.16 0 01.08-.14l2.3-1.3a.16.16 0 00.06-.21l-.66-1.12A.17.17 0 003.7 1L1.78 2.11l-1.2.67a.16.16 0 00-.08.14v12.16z" fill="#949494" />
    <path d="M2.14 3.77l.06-.06 2.3-1.3a.14.14 0 00.06-.21L3.9 1.08A.15.15 0 003.68 1L1.75 2.11l-1.19.67s-.05 0-.06.06l.9.51zM4.5 15.59l-2.3-1.3a.22.22 0 01-.07-.09l-1.62 1h.05l1.15.65 2 1.11a.15.15 0 00.22-.06l.66-1.12a.14.14 0 00-.09-.19z" fill="#a3a3a3" />
    <path d="M17.5 15.08a.16.16 0 01-.08.14l-1.16.65L14.3 17a.17.17 0 01-.23-.06l-.66-1.12a.16.16 0 01.06-.21l2.3-1.3a.17.17 0 00.08-.14V3.85a.16.16 0 00-.08-.14l-2.3-1.3a.16.16 0 01-.06-.21l.66-1.12A.17.17 0 0114.3 1l1.92 1.09 1.2.67a.16.16 0 01.08.14v12.18z" fill="#949494" />
    <path d="M15.86 3.77l-.06-.06-2.3-1.3a.14.14 0 01-.06-.21l.66-1.12a.15.15 0 01.22-.08l1.93 1.09 1.19.67.06.06-.9.51zM13.5 15.59l2.3-1.3a.22.22 0 00.07-.09l1.62 1-1.15.65-2 1.11a.15.15 0 01-.22-.06l-.66-1.12a.14.14 0 01.04-.19z" fill="#a3a3a3" />
    <path fill="#32bedd" d="M14.31 5.93v6.14l-5.32 3.09V9.01l5.32-3.08z" />
    <path fill="#9cebff" d="M14.31 5.93L9 9.02 3.68 5.93 9 2.84l5.31 3.09z" />
    <path fill="#50e6ff" d="M8.99 9.02v6.14l-5.31-3.09V5.93l5.31 3.09z" />
    <path fill="#9cebff" d="M3.68 12.07l5.31-3.06v6.15l-5.31-3.09z" />
    <path fill="#50e6ff" d="M14.31 12.07L8.99 9.01v6.15l5.32-3.09z" />
  </svg>
);

const AppServices = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <defs>
      <linearGradient id="b" x1="4.4" y1="11.48" x2="4.37" y2="7.53" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#ccc" />
        <stop offset="1" stopColor="#fcfcfc" />
      </linearGradient>
      <linearGradient id="c" x1="10.13" y1="15.45" x2="10.13" y2="11.9" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#ccc" />
        <stop offset="1" stopColor="#fcfcfc" />
      </linearGradient>
      <linearGradient id="d" x1="14.18" y1="11.15" x2="14.18" y2="7.38" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#ccc" />
        <stop offset="1" stopColor="#fcfcfc" />
      </linearGradient>
      <radialGradient id="a" cx="13428.81" cy="3518.86" r="56.67" gradientTransform="matrix(.15 0 0 .15 -2005.33 -518.83)" gradientUnits="userSpaceOnUse">
        <stop offset=".18" stopColor="#5ea0ef" />
        <stop offset="1" stopColor="#0078d4" />
      </radialGradient>
    </defs>
    <path d="M14.21 15.72A8.5 8.5 0 013.79 2.28l.09-.06a8.5 8.5 0 0110.33 13.5" fill="url(#a)" />
    <path d="M6.69 7.23a13 13 0 018.91-3.58 8.47 8.47 0 00-1.49-1.44 14.34 14.34 0 00-4.69 1.1 12.54 12.54 0 00-4.08 2.82 2.76 2.76 0 011.35 1.1zM2.48 10.65a17.86 17.86 0 00-.83 2.62 7.82 7.82 0 00.62.92c.18.23.35.44.55.65a17.94 17.94 0 011.08-3.47 2.76 2.76 0 01-1.42-.72z" fill="#fff" opacity=".6" />
    <path d="M3.46 6.11a12 12 0 01-.69-2.94 8.15 8.15 0 00-1.1 1.45A12.69 12.69 0 002.24 7a2.69 2.69 0 011.22-.89z" fill="#f2f2f2" opacity=".55" />
    <circle cx="4.38" cy="8.68" r="2.73" fill="url(#b)" />
    <path d="M8.36 13.67a1.77 1.77 0 01.54-1.27 11.88 11.88 0 01-2.53-1.86 2.74 2.74 0 01-1.49.83 13.1 13.1 0 001.45 1.28 12.12 12.12 0 002.05 1.25 1.79 1.79 0 01-.02-.23zM14.66 13.88a12 12 0 01-2.76-.32.41.41 0 010 .11 1.75 1.75 0 01-.51 1.24 13.69 13.69 0 003.42.24A8.21 8.21 0 0016 13.81a11.5 11.5 0 01-1.34.07z" fill="#f2f2f2" opacity=".55" />
    <circle cx="10.13" cy="13.67" r="1.78" fill="url(#c)" />
    <path d="M12.32 8.93a1.83 1.83 0 01.61-1 25.5 25.5 0 01-4.46-4.14 16.91 16.91 0 01-2-2.92 7.64 7.64 0 00-1.09.42 18.14 18.14 0 002.15 3.18 26.44 26.44 0 004.79 4.46z" fill="#f2f2f2" opacity=".7" />
    <circle cx="14.18" cy="9.27" r="1.89" fill="url(#d)" />
    <path d="M17.35 10.54l-.35-.17-.3-.16h-.06l-.26-.21h-.07L16 9.8a1.76 1.76 0 01-.64.92c.12.08.25.15.38.22l.08.05.35.19.86.45a8.63 8.63 0 00.29-1.11z" fill="#f2f2f2" opacity=".55" />
    <circle cx="4.38" cy="8.68" r="2.73" fill="url(#b)" />
    <circle cx="10.13" cy="13.67" r="1.78" fill="url(#c)" />
  </svg>
);

const Resources = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <defs>
      <linearGradient id="a" x1="8.88" y1="17.09" x2="8.88" y2="1.09" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#5e9624" />
        <stop offset=".01" stopColor="#5e9724" />
        <stop offset=".35" stopColor="#6cab29" />
        <stop offset=".68" stopColor="#73b82c" />
        <stop offset="1" stopColor="#76bc2d" />
      </linearGradient>
    </defs>
    <path d="M6.48 12.29h4.8v4.8h-4.8zm-5.6-6.4h4.8v-4.8H1.55a.67.67 0 00-.67.67zm.67 11.2h4.13v-4.8H.88v4.13a.67.67 0 00.67.67zm-.67-5.6h4.8v-4.8H.88zm11.2 5.6h4.14a.67.67 0 00.66-.67v-4.13h-4.8zm-5.6-5.6h4.8v-4.8h-4.8zm5.6 0h4.8v-4.8h-4.8zm0-10.4v4.8h4.8V1.76a.67.67 0 00-.66-.67zm-5.6 4.8h4.8v-4.8h-4.8z" fill="url(#a)" />
  </svg>
);

const FunctionApp = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <defs>
      <linearGradient id="a" x1="-175.993" y1="-343.723" x2="-175.993" y2="-359.232" gradientTransform="matrix(1.156 0 0 1.029 212.573 370.548)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#fea11b" />
        <stop offset=".284" stopColor="#fea51a" />
        <stop offset=".547" stopColor="#feb018" />
        <stop offset=".8" stopColor="#ffc314" />
        <stop offset="1" stopColor="#ffd70f" />
      </linearGradient>
    </defs>
    <path d="M5.54 13.105l-.586.588a.267.267 0 01-.377 0L.223 9.353a.533.533 0 010-.755l.588-.59 4.732 4.718a.267.267 0 010 .378z" fill="#50e6ff" />
    <path d="M4.863 4.305l.59.588a.267.267 0 010 .378L.806 9.932l-.59-.589a.533.533 0 01-.001-.754l4.273-4.285a.267.267 0 01.376 0z" fill="#1490df" />
    <path d="M17.19 8.012l.588.59a.533.533 0 01-.001.754l-4.354 4.34a.267.267 0 01-.377 0l-.586-.587a.267.267 0 010-.377l4.732-4.718z" fill="#50e6ff" />
    <path d="M17.782 9.34l-.59.589-4.648-4.662a.267.267 0 010-.377l.59-.588a.267.267 0 01.378 0l4.273 4.286a.533.533 0 010 .753z" fill="#1490df" />
    <path d="M8.459 9.9H4.87a.193.193 0 01-.2-.181.166.166 0 01.018-.075L8.991 1.13a.206.206 0 01.186-.106h4.245a.193.193 0 01.2.181.165.165 0 01-.035.1L8.534 7.966h4.928a.193.193 0 01.2.181.176.176 0 01-.052.122l-8.189 8.519c-.077.046-.624.5-.356-.189z" fill="url(#a)" />
  </svg>
);

const SQLDatabase = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <defs>
      <radialGradient id="b" cx="9.36" cy="10.57" r="7.07" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#f2f2f2" />
        <stop offset=".58" stopColor="#eee" />
        <stop offset="1" stopColor="#e6e6e6" />
      </radialGradient>
      <linearGradient id="a" x1="2.59" y1="10.16" x2="15.41" y2="10.16" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#005ba1" />
        <stop offset=".07" stopColor="#0060a9" />
        <stop offset=".36" stopColor="#0071c8" />
        <stop offset=".52" stopColor="#0078d4" />
        <stop offset=".64" stopColor="#0074cd" />
        <stop offset=".82" stopColor="#006abb" />
        <stop offset="1" stopColor="#005ba1" />
      </linearGradient>
    </defs>
    <path d="M9 5.14c-3.54 0-6.41-1-6.41-2.32v12.36c0 1.27 2.82 2.3 6.32 2.32H9c3.54 0 6.41-1 6.41-2.32V2.82c0 1.29-2.87 2.32-6.41 2.32z" fill="url(#a)" />
    <path d="M15.41 2.82c0 1.29-2.87 2.32-6.41 2.32s-6.41-1-6.41-2.32S5.46.5 9 .5s6.41 1 6.41 2.32" fill="#e8e8e8" />
    <path d="M13.92 2.63c0 .82-2.21 1.48-4.92 1.48s-4.92-.66-4.92-1.48S6.29 1.16 9 1.16s4.92.66 4.92 1.47" fill="#50e6ff" />
    <path d="M9 3a11.55 11.55 0 00-3.89.57A11.42 11.42 0 009 4.11a11.15 11.15 0 003.89-.58A11.84 11.84 0 009 3z" fill="#198ab3" />
    <path d="M12.9 11.4V8H12v4.13h2.46v-.73zM5.76 9.73a1.83 1.83 0 01-.51-.31.44.44 0 01-.12-.32.34.34 0 01.15-.3.68.68 0 01.42-.12 1.62 1.62 0 011 .29v-.86a2.58 2.58 0 00-1-.16 1.64 1.64 0 00-1.09.34 1.08 1.08 0 00-.42.89c0 .51.32.91 1 1.21a2.88 2.88 0 01.62.36.42.42 0 01.15.32.38.38 0 01-.16.31.81.81 0 01-.45.11 1.66 1.66 0 01-1.09-.42V12a2.17 2.17 0 001.07.24 1.88 1.88 0 001.18-.33 1.08 1.08 0 00.33-.91 1.05 1.05 0 00-.25-.7 2.42 2.42 0 00-.83-.57zM11 11.32a2.34 2.34 0 00.33-1.26A2.32 2.32 0 0011 9a1.81 1.81 0 00-.7-.75 2 2 0 00-1-.26 2.11 2.11 0 00-1.08.27 1.86 1.86 0 00-.73.74 2.46 2.46 0 00-.26 1.14 2.26 2.26 0 00.24 1 1.76 1.76 0 00.69.74 2.06 2.06 0 001 .3l.86 1h1.21L10 12.08a1.79 1.79 0 001-.76zm-1-.25a.94.94 0 01-.76.35.92.92 0 01-.76-.36 1.52 1.52 0 01-.29-1 1.53 1.53 0 01.29-1 1 1 0 01.78-.37.87.87 0 01.75.37 1.62 1.62 0 01.27 1 1.46 1.46 0 01-.28 1.01z" fill="url(#b)" />
  </svg>
);

const Quickstart = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <defs>
      <linearGradient id="a" x1="8.47" y1="2.89" x2="14.96" y2="9.62" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#dfa500" />
        <stop offset=".28" stopColor="#efb700" />
        <stop offset=".51" stopColor="#ffca00" />
        <stop offset="1" stopColor="#e1a800" />
      </linearGradient>
      <linearGradient id="b" x1="6.86" y1="11.19" x2="-.99" y2="18.81" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#faa21d" />
        <stop offset=".24" stopColor="#f99d1a" />
        <stop offset=".51" stopColor="#f69012" />
        <stop offset=".8" stopColor="#f17905" />
        <stop offset=".88" stopColor="#ef7100" />
      </linearGradient>
    </defs>
    <path d="M4.07 10.44a5.66 5.66 0 00-3-1.14.28.28 0 01-.27-.41 5.35 5.35 0 011.51-1.71 4.87 4.87 0 014.4-.85 1.67 1.67 0 01.62.27zM7.7 14.06l3.84-3.26a1.82 1.82 0 01.27.63 4.91 4.91 0 01-.86 4.4 5.21 5.21 0 01-1.71 1.48.28.28 0 01-.41-.31 5.73 5.73 0 00-1.13-2.94z" fill="#f78d1e" />
    <path d="M17.38.27A24.27 24.27 0 004 10.31L7.69 14A24.27 24.27 0 0017.73.62a.29.29 0 00-.35-.35z" fill="#fcd116" />
    <path d="M17.38.27A24.27 24.27 0 004 10.31L7.69 14A24.27 24.27 0 0017.73.62a.29.29 0 00-.35-.35z" fill="#dfa500" />
    <path d="M17.38.27a22 22 0 00-4.45 1.83l3 3a22 22 0 001.8-4.48.29.29 0 00-.35-.35z" fill="#0078d4" />
    <path d="M.26 17.44A10.32 10.32 0 014 10.31L7.69 14a10.32 10.32 0 01-7.13 3.74.28.28 0 01-.3-.3z" fill="url(#b)" />
    <circle cx="11.42" cy="6.58" r="1.91" fill="#dfa500" />
    <circle cx="11.42" cy="6.58" r="1.43" fill="#f2f2f2" />
    <path d="M5.16 13.59a3 3 0 01-1.33.59 3.3 3.3 0 01.58-1.34L8 9.24l.75.75z" fill="#d15900" />
  </svg>
);

const AllServices = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <defs>
      <linearGradient id="a" x1="-655.644" y1="751.401" x2="-655.644" y2="763.239" gradientTransform="translate(667.725 -742.844)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#76bc2d" />
        <stop offset=".312" stopColor="#72b62c" />
        <stop offset="1" stopColor="#5e9624" />
      </linearGradient>
      <linearGradient id="b" x1="-650.227" y1="759.495" x2="-650.227" y2="763.239" gradientTransform="translate(666.355 -752.308)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#76bc2d" />
        <stop offset=".312" stopColor="#72b62c" />
        <stop offset="1" stopColor="#5e9624" />
      </linearGradient>
      <linearGradient id="c" x1="-644.724" y1="751.401" x2="-644.724" y2="763.239" gradientTransform="translate(656.805 -753.765)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#76bc2d" />
        <stop offset=".312" stopColor="#72b62c" />
        <stop offset="1" stopColor="#5e9624" />
      </linearGradient>
    </defs>
    <rect x="7.753" y="5.476" width="2.494" height="18" rx=".596" transform="rotate(-90 9 14.476)" fill="#5e9624" />
    <rect x="7.753" y=".059" width="2.494" height="18" rx=".596" transform="rotate(-90 9 9.059)" fill="#5e9624" />
    <rect x="7.753" y="-5.444" width="2.494" height="18" rx=".596" transform="rotate(-90 9 3.556)" fill="#5e9624" />
    <rect x="10.834" y="8.557" width="2.494" height="11.838" rx=".596" transform="rotate(-90 12.081 14.476)" fill="url(#a)" />
    <rect x="14.881" y="7.187" width="2.494" height="3.744" rx=".596" transform="rotate(-90 16.128 9.06)" fill="url(#b)" />
    <rect x="10.834" y="-2.363" width="2.494" height="11.838" rx=".596" transform="rotate(-90 12.081 3.556)" fill="url(#c)" />
    <rect x="4.74" y="13.855" width="3.766" height="1.178" rx=".589" transform="rotate(-90 6.623 14.444)" fill="#e6e6e6" />
    <rect x="12.671" y="8.419" width="3.766" height="1.178" rx=".589" transform="rotate(-90 14.554 9.008)" fill="#e6e6e6" />
    <rect x="4.74" y="2.967" width="3.766" height="1.178" rx=".589" transform="rotate(-90 6.623 3.556)" fill="#e6e6e6" />
  </svg>
);

const Dashboard = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <defs>
      <linearGradient id="a" x1="8.51" y1=".58" x2="8.51" y2="17.27" gradientUnits="userSpaceOnUse">
        <stop offset=".09" stopColor="#6cc6b9" />
        <stop offset=".46" stopColor="#6ac4b7" />
        <stop offset=".64" stopColor="#62bdb0" />
        <stop offset=".77" stopColor="#56b1a4" />
        <stop offset=".88" stopColor="#439f93" />
        <stop offset=".98" stopColor="#2c897d" />
        <stop offset="1" stopColor="#258277" />
      </linearGradient>
    </defs>
    <path d="M.06 2.49H17a.52.52 0 01.54.49v11.77a.52.52 0 01-.54.49H.06a.53.53 0 01-.55-.49V3a.53.53 0 01.55-.51z" fill="#6cc6b9" />
    <path d="M7 4h8.09a.16.16 0 01.16.15v4.47a.16.16 0 01-.16.15H7a.16.16 0 01-.16-.15V4.14A.16.16 0 017 4z" fill="#fff" />
    <rect x="1.75" y="3.99" width="3.41" height="9.61" rx=".15" fill="#fff" />
    <path d="M11.92 10.12h3.14a.15.15 0 01.15.15v3.19a.15.15 0 01-.15.14h-3.14a.15.15 0 01-.15-.14v-3.19a.15.15 0 01.15-.15zM6.95 10.12H10a.15.15 0 01.15.15v3.19a.14.14 0 01-.14.14H7a.15.15 0 01-.15-.15v-3.18a.14.14 0 01.1-.15z" fill="#fff" />
  </svg>
);

export const NotificationBell = (
  <svg style={{ filter: "grayscale(100%)", opacity: 0.4 }} width="100" height="100" viewBox="0 0 13.714 16" aria-hidden="true" focusable="false" className="" role="presentation" xmlns="http://www.w3.org/2000/svg">
    <g>
      <title />
      <path d="M6.857 16a2.86 2.86 0 0 0 2.857-2.857h4V12h-1.143V5.714C12.571 2.563 10.008 0 6.857 0S1.143 2.563 1.143 5.714V12H0v1.143h4A2.86 2.86 0 0 0 6.857 16z" style={{ fill: "#fcd116" }} />
      <path d="M6.857 14.857a1.716 1.716 0 0 1-1.714-1.714h3.429a1.718 1.718 0 0 1-1.715 1.714z" opacity=".8" style={{ fill: "#fcd116" }} />
      <path d="M0 12h13.714v1.143H0z" opacity=".4" style={{ fill: "#ff8c00" }} />
      <path d="M6.857 12V0a5.72 5.72 0 0 0-5.714 5.714V12h5.714z" opacity=".8" style={{ fill: "#fcd116" }} />
      <path d="M6.857 12V0a5.72 5.72 0 0 0-5.714 5.714V12h5.714z" opacity=".4" style={{ fill: "#ff8c00" }} />
      <path d="M8.571 13.152c0 1-.769 1.714-1.714 1.714s-1.714-.714-1.714-1.714L4 13.143C4 14.718 5.282 16 6.857 16s2.857-1.282 2.857-2.857l-1.143.009z" opacity=".7" style={{ fill: "#dd5900" }} />
    </g>
  </svg>
);

const AddSvg = (
  <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="1" y1="13.5" x2="28" y2="13.5" stroke="#0572CE" strokeWidth="2" strokeLinecap="round" />
    <line x1="1" y1="13.5" x2="28" y2="13.5" stroke="#0572CE" strokeWidth="2" strokeLinecap="round" />
    <line x1="1" y1="13.5" x2="28" y2="13.5" stroke="#0572CE" strokeWidth="2" strokeLinecap="round" />
    <line x1="14.5" y1="28" x2="14.5" y2="1" stroke="#0572CE" strokeWidth="2" strokeLinecap="round" />
    <line x1="14.5" y1="28" x2="14.5" y2="1" stroke="#0572CE" strokeWidth="2" strokeLinecap="round" />
    <line x1="14.5" y1="28" x2="14.5" y2="1" stroke="#0572CE" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const Billing = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 18 18"
  >
    <defs>
      <radialGradient id="a" cx="7.18" cy="9.5" r="7.38" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#76bc2d" />
        <stop offset=".41" stopColor="#74b92c" />
        <stop offset=".66" stopColor="#6fb12a" />
        <stop offset=".88" stopColor="#66a227" />
        <stop offset="1" stopColor="#5e9624" />
      </radialGradient>
    </defs>
    <path d="M10 10.24a1 1 0 01-.31.79 1.49 1.49 0 01-.89.37v.6h-.44v-.62a2.36 2.36 0 01-1.1-.28v-.81a1.8 1.8 0 00.5.25 2.49 2.49 0 00.6.14V9.64a2.42 2.42 0 01-.91-.53 1.15 1.15 0 01.06-1.55 1.41 1.41 0 01.85-.38v-.55h.43v.54a2.21 2.21 0 01.92.2v.8a2.28 2.28 0 00-.92-.31V9a2.34 2.34 0 01.92.54 1 1 0 01.29.7zM8.36 8.81v-.93A.4.4 0 008 8.3c0 .21.13.38.4.51zm.85 1.47c0-.19-.14-.34-.42-.47v.9c.28-.05.42-.19.42-.43z" fill="#258277" />
    <path d="M16.54 9.49h-3.6a4.43 4.43 0 01-1.48 3.3l2.39 2.69a8 8 0 002.69-6" fill="#ffca00" />
    <path d="M8.52 13.93a4.43 4.43 0 010-8.86V1.49a8 8 0 00-8 8 8 8 0 008 8 8 8 0 005.34-2l-2.4-2.69a4.38 4.38 0 01-2.94 1.13z" fill="#76bc2d" />
    <path d="M8.15.48v4.16a5.09 5.09 0 015.17 5.18h4.18A9.34 9.34 0 008.15.48z" fill="#ccc" />
    <path d="M13.34 9.82a5.13 5.13 0 00-5.06-5.18h-.13l.33.62a4.5 4.5 0 014.23 4.25z" fill="#999" />
  </svg>
);

const ExadataWatermarkSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none" style={{ width: "100px", height: "100px", opacity: 0.5 }}>
    <g clipPath="url(#clip0_1561_14446)">
      <rect width="35" height="35" />
      <path d="M18.375 2.33334L9.66666 5.63945V30.5728L18.375 31.6667V2.33334Z" fill="url(#paint0_linear_1561_14446)" />
      <path d="M17.3422 6.44917L11.1807 8.38639V7.81195L17.3422 5.8075V6.44917Z" fill="#898989" />
      <path d="M17.3422 11.3381L11.1807 12.765V12.1906L17.3422 10.6964V11.3381Z" fill="#898989" />
      <path d="M12.6626 9.58111L11.1807 10.0012V10.5757L12.6626 10.1708V9.58111Z" fill="#898989" />
      <path d="M15.599 8.74695V9.37028L17.3422 8.89361V8.25195L15.599 8.74695Z" fill="#898989" />
      <path d="M14.9574 10.4703L13.2539 10.9072V8.51931L14.9574 8.00903V10.4703Z" fill="#898989" />
      <path d="M17.3422 16.2269L11.1807 17.1436V14.3768L17.3422 13.1362V16.2269Z" fill="white" />
      <path d="M17.3422 18.6699L11.1807 19.3344V18.7585L17.3422 18.0297V18.6699Z" fill="#898989" />
      <path d="M14.9992 24.8379L16.7918 21L15.6403 21.0466L14.3867 23.8673L13.1923 21.1459L12.0878 21.1905L13.7803 24.8298L12 28.6981L13.0494 28.7629L14.3356 25.77L15.7485 28.925L17 29L14.9992 24.8379Z" fill="white" />
      <path d="M18.375 2.33334L9.66666 5.63945V30.5728L18.375 31.6667L24.3333 30.5651V5.63334L18.375 2.33334ZM18.375 30.4444L10.5833 29.6301V6.34986L18.375 3.55556V30.4444Z" fill="url(#paint2_linear_1561_14446)" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_1561_14446" x1="14.0208" y1="2.33334" x2="14.0208" y2="31.6667" gradientUnits="userSpaceOnUse">
        <stop stopColor="#CCCCCC" />
        <stop offset="1" stopColor="#ABABAB" />
      </linearGradient>
      <linearGradient id="paint1_linear_1561_14446" x1="14.1056" y1="8.00903" x2="14.1056" y2="10.9072" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F80000" />
        <stop offset="1" stopColor="#DE0000" />
      </linearGradient>
      <linearGradient id="paint2_linear_1561_14446" x1="17" y1="2.33334" x2="17" y2="31.6667" gradientUnits="userSpaceOnUse">
        <stop stopColor="#898989" />
        <stop offset="1" stopColor="#5A5A5A" />
      </linearGradient>
      <clipPath id="clip0_1561_14446">
        <rect width="35" height="35" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ExadataSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
    <g clipPath="url(#clip0_1561_14446)">
      <rect width="35" height="35" />
      <path d="M18.375 2.33334L9.66666 5.63945V30.5728L18.375 31.6667V2.33334Z" fill="url(#paint0_linear_1561_14446)" />
      <path d="M17.3422 6.44917L11.1807 8.38639V7.81195L17.3422 5.8075V6.44917Z" fill="#898989" />
      <path d="M17.3422 11.3381L11.1807 12.765V12.1906L17.3422 10.6964V11.3381Z" fill="#898989" />
      <path d="M12.6626 9.58111L11.1807 10.0012V10.5757L12.6626 10.1708V9.58111Z" fill="#898989" />
      <path d="M15.599 8.74695V9.37028L17.3422 8.89361V8.25195L15.599 8.74695Z" fill="#898989" />
      <path d="M14.9574 10.4703L13.2539 10.9072V8.51931L14.9574 8.00903V10.4703Z" fill="url(#paint1_linear_1561_14446)" />
      <path d="M17.3422 16.2269L11.1807 17.1436V14.3768L17.3422 13.1362V16.2269Z" fill="white" />
      <path d="M17.3422 18.6699L11.1807 19.3344V18.7585L17.3422 18.0297V18.6699Z" fill="#898989" />
      <path d="M14.9992 24.8379L16.7918 21L15.6403 21.0466L14.3867 23.8673L13.1923 21.1459L12.0878 21.1905L13.7803 24.8298L12 28.6981L13.0494 28.7629L14.3356 25.77L15.7485 28.925L17 29L14.9992 24.8379Z" fill="white" />
      <path d="M18.375 2.33334L9.66666 5.63945V30.5728L18.375 31.6667L24.3333 30.5651V5.63334L18.375 2.33334ZM18.375 30.4444L10.5833 29.6301V6.34986L18.375 3.55556V30.4444Z" fill="url(#paint2_linear_1561_14446)" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_1561_14446" x1="14.0208" y1="2.33334" x2="14.0208" y2="31.6667" gradientUnits="userSpaceOnUse">
        <stop stopColor="#CCCCCC" />
        <stop offset="1" stopColor="#ABABAB" />
      </linearGradient>
      <linearGradient id="paint1_linear_1561_14446" x1="14.1056" y1="8.00903" x2="14.1056" y2="10.9072" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F80000" />
        <stop offset="1" stopColor="#DE0000" />
      </linearGradient>
      <linearGradient id="paint2_linear_1561_14446" x1="17" y1="2.33334" x2="17" y2="31.6667" gradientUnits="userSpaceOnUse">
        <stop stopColor="#898989" />
        <stop offset="1" stopColor="#5A5A5A" />
      </linearGradient>
      <clipPath id="clip0_1561_14446">
        <rect width="35" height="35" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const Activity = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="36" height="36">
    <g>
      <title />
      <defs>
        <linearGradient id="9186097d-743a-4f73-97aa-ca8d7dc6a02e" x1="8.15" x2="8.15" y1="17.5" y2="2.09" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#1988d9" />
          <stop offset=".9" stopColor="#54aef0" />
        </linearGradient>
      </defs>
      <path
        fill="#005ba1"
        d="M1.93 2.11 3.14.7a.59.59 0 0 1 .45-.2H15.2a.81.81 0 0 1 .89.83v14.5a.57.57 0 0 1-.2.43l-1.3 1.19H2.72l-.81-.33z"
      />
      <path
        d="m2.91 2.1.74-.84A.5.5 0 0 1 4 1.08h10.89a.52.52 0 0 1 .52.52v13.78a.52.52 0 0 1-.17.39l-1.16 1.05z"
        fill="#fff"
      />
      <path
        fill="url(#9186097d-743a-4f73-97aa-ca8d7dc6a02e)"
        d="M14 2.09H2a.06.06 0 0 0-.06.06v15a.39.39 0 0 0 .39.38H14a.38.38 0 0 0 .38-.38V2.48a.39.39 0 0 0-.38-.39z"
      />
      <rect
        width="6.58"
        height="2.38"
        x="4.72"
        y="6.2"
        rx=".28"
        fill="#fff"
      />
    </g>
  </svg>
);

const HeatWave = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.6551 3.79879V13.2822H3.13086V1.9165H9.77235L11.6551 3.79879Z" fill="url(#paint0_linear_223_17246)" />
    <path opacity="0.5" d="M9.77148 1.9165V3.83993L11.6543 3.79879L9.77148 1.9165Z" fill="white" />
    <path opacity="0.5" d="M6.97593 5.0057H4.23633V5.47216H6.97593V5.0057ZM4.23633 4.30627H8.25804V3.84033H4.23633V4.30627Z" fill="white" />
    <path d="M11.3721 16.0832C13.3036 16.0832 14.8693 14.5174 14.8693 12.586C14.8693 10.6546 13.3036 9.08887 11.3721 9.08887C9.44072 9.08887 7.875 10.6546 7.875 12.586C7.875 14.5174 9.44072 16.0832 11.3721 16.0832Z" fill="url(#paint1_linear_223_17246)" />
    <path d="M13.2939 12.914H11.0449V10.7808H11.7006V12.2583H13.2939V12.914Z" fill="#005BA1" />
    <defs>
      <linearGradient id="paint0_linear_223_17246" x1="7.39274" y1="13.2822" x2="7.39274" y2="1.9165" gradientUnits="userSpaceOnUse">
        <stop stopColor="#0078D4" />
        <stop offset="0.16" stopColor="#1380DA" />
        <stop offset="0.53" stopColor="#3C91E5" />
        <stop offset="0.82" stopColor="#559CEC" />
        <stop offset="1" stopColor="#5EA0EF" />
      </linearGradient>
      <linearGradient id="paint1_linear_223_17246" x1="7.875" y1="12.586" x2="14.8693" y2="12.586" gradientUnits="userSpaceOnUse">
        <stop stopColor="#D9D9D9" />
        <stop offset="1" stopColor="#E6E6E6" />
      </linearGradient>
    </defs>
  </svg>
);

const TagEnabled = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 17" style={{ width: "16px", height: "16px" }}>
    <path fill="rgb(0, 120, 212)" d="M2.7 7.3L1.4 6l5-5H10v2h1V0H6L0 6l2 2 .7-.7zM8 6l-6 6 5 5 6-6V6zm4 4.6l-5 5L3.4 12l5-5H12z" />
    <path fill="rgb(0, 120, 212)" d="M3.7 10.3L2.4 9l5-5H11v2h1V3H7L1 9l2 2 .7-.7z" />
    <circle fill="rgb(0, 120, 212)" cx="10.5" cy="8.5" r=".5" />
  </svg>
);

const TagDisabled = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 17" style={{ width: "16px", height: "16px" }}>
    <path fill="rgb(200, 198, 196)" d="M2.7 7.3L1.4 6l5-5H10v2h1V0H6L0 6l2 2 .7-.7zM8 6l-6 6 5 5 6-6V6zm4 4.6l-5 5L3.4 12l5-5H12z" />
    <path fill="rgb(200, 198, 196)" d="M3.7 10.3L2.4 9l5-5H11v2h1V3H7L1 9l2 2 .7-.7z" />
    <circle fill="rgb(200, 198, 196)" cx="10.5" cy="8.5" r=".5" />
  </svg>
);

const Tags = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <defs>
      <linearGradient id="tags-linear-gradient-01" x1="9.84" y1="3.825" x2="9.84" y2="17.5" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#c69aeb" />
        <stop offset="1" stopColor="#6f4bb2" />
      </linearGradient>
    </defs>
    <path d="M14.977 2.5L13.1.635A.471.471 0 0012.753.5L9.271.627a.462.462 0 00-.312.135L1.342 8.339a.462.462 0 000 .654l5.074 5.047a.465.465 0 00.657 0L14.7 6.454a.456.456 0 00.134-.288l.279-3.3a.461.461 0 00-.136-.366zm-2.266 1.237a.843.843 0 11.848-.843.845.845 0 01-.848.843z" fill="#773adc" />
    <path d="M12.711 1.383a1.512 1.512 0 101.52 1.511 1.515 1.515 0 00-1.52-1.511zm.832 1.676a.848.848 0 11-1-.992.84.84 0 011 .992z" fill="#341a6e" />
    <path d="M16.658 5.828L14.78 3.96a.466.466 0 00-.346-.135l-3.483.126a.473.473 0 00-.312.135l-7.616 7.577a.46.46 0 000 .654L8.1 17.365a.467.467 0 00.657 0l7.623-7.586a.464.464 0 00.134-.288l.278-3.3a.459.459 0 00-.134-.363zm-2.266 1.234a.843.843 0 11.847-.843.846.846 0 01-.847.843z" fill="url(#tags-linear-gradient-01)" />
    <path d="M14.392 4.707a1.512 1.512 0 101.519 1.512 1.516 1.516 0 00-1.519-1.512zm.831 1.677a.848.848 0 11-1-.992.842.842 0 011 .992z" fill="#552f99" />
    <path d="M15.223 6.384a.848.848 0 11-1-.992.842.842 0 011 .992zM13.543 3.059a.848.848 0 11-1-.992.84.84 0 011 .992z" fill="#fff" />
  </svg>
);

const HelpSvg = (
  <svg viewBox="0 2 16 16" width="22" height="22" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 16 16">
    <path d="M8 2C4.69 2 2 4.69 2 8s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 11c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" fill="currentColor" />
    <path d="M8.43 4.55c-.96-.24-2.03.37-2.32 1.31-.09.27.06.55.32.63s.54-.06.63-.33c.14-.44.68-.75 1.14-.64.45.11.79.64.7 1.1-.08.46-.57.83-1.04.77a.497.497 0 0 0-.56.5l-.01 1.56c0 .28.22.5.5.5s.5-.22.5-.5l.01-1.09c.77-.15 1.45-.78 1.59-1.57.18-.97-.49-2-1.46-2.24zM7.81 10.39H7.8c-.27 0-.49.23-.5.5V11c0 .27.22.45.49.46h.01c.27 0 .49-.25.5-.52v-.08a.48.48 0 0 0-.49-.47z" fill="currentColor" />
  </svg>
);

const DeploymentSvg = (
  <svg viewBox="0 0 35 35" width="35" height="35" fill="#015cda" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <symbol viewBox="0 0 13 16" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="FxSymbol0-03f" data-type="96">
        <g>
          <title />
          <path d="M10.6 5.6 7 1.9V9H6V1.9L2.4 5.6l-.8-.7L6.5 0l4.9 4.9zM0 10v6h13v-6zm12 5H1v-4h11z" />
        </g>
      </symbol>
    </defs>
    <use href="#FxSymbol0-03f" />
  </svg>
);

const DeploymentDetailSvg = (
  <svg viewBox="0 0 35 35" width="35" height="35" fill="#015cda" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <symbol viewBox="0 0 18 18" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="deployment" data-type="15">
        <g>
          <title />
          <title>MsPortalFx.base.images-18</title>
          <path fill="#76bc2d" d="M13.067 2.794v4.791L8.926 9.993V5.194l4.141-2.4z" />
          <path fill="#b4ec36" d="M13.067 2.794 8.926 5.201 4.785 2.793 8.926.386l4.141 2.408z" />
          <path fill="#86d633" d="M8.926 5.201v4.792L4.785 7.585V2.793l4.141 2.408z" />
          <path fill="#76bc2d" d="M8.782 10.416v4.791l-4.141 2.407v-4.798l4.141-2.4z" />
          <path fill="#b4ec36" d="m8.782 10.416-4.141 2.406L.5 10.415l4.141-2.408 4.141 2.409z" />
          <path fill="#86d633" d="M4.641 12.822v4.792L.5 15.207v-4.792l4.141 2.407z" />
          <path fill="#76bc2d" d="M17.5 10.416v4.791l-4.141 2.407v-4.798l4.141-2.4z" />
          <path fill="#b4ec36" d="m17.5 10.416-4.14 2.406-4.142-2.407 4.142-2.408 4.14 2.409z" />
          <path fill="#86d633" d="M13.359 12.822v4.792l-4.141-2.407v-4.792l4.141 2.407z" />
        </g>
      </symbol>
    </defs>
    <use href="#deployment" />
  </svg>
);

const DeploymentMetaIconSvg = (
  <svg viewBox="0 0 26 26" width="26" height="26" fill="#015cda" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <image id="image0_503_6770" width="26" height="26" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAMAAAAPdrEwAAAAM1BMVEVoIXr////ZyN7s4+6OWZtxL4L28feqgrSES5OhdKy0kL17PYu9nsXQutXj1ebGrM2XZqQDIVGNAAAB1UlEQVR4Xu2X2Y6kMAxF+9pZ2f//a0cRjDyUI3B6Xlpqn0dUHBcXJzFfvwPHcRzHcZx5ZwAdQSkdAQBeZpt5QgO64gqQdqCBajFXdNXxqrjErhqHQZ0ArLMqmHCRssppBZDezQEAqYsbBHD4FDCAYEo6q5Bv6MgzgMmkDjpkoRd5sKtVyJqUh9VZ1BJyFw43dTW9xix1HllUio/M/94SCQ9w+StYABgW5L35AgPvYROAr3f4o69zwmuLMMAGtfyDlWtzxwXoN/ZMqzzpkJoACqdC9cZVkkbVSYpgnz8jT1mCUmpj1nSapniaJGSpJb80ZL1L9xNO+JDIqdx2FZL+35+9dWIAm0TTECHxcdtVJIYNAE/1OecWgFIDe+zsKqKOiySvEBn11EiT7CodNeFFXaam2y436XUdV6CjjtzEU7AdBVrdts0ArZab7M1nV5N5oacB9fhC//nq/896s2WNQbX9KCinY7z5ivXYHVeHkTmkbG9qPr494tSk1GpbGVXrqUyr9zg+PSGrWVKrKaibLK+R71c2reZ6CWTjK6Ylg7Wouf1Sy3EpFIJtyRw4+RyERb3Ptg8OTRX1LfJLTcH4mWT/uAtbbjOCcgDg9hy/AcdxHMdxnD/x0Q3o+TccswAAAABJRU5ErkJggg==" />
    </defs>
    <use href="#image0_503_6770" />
  </svg>
);

const DeploymentWatermarkSvg = (
  <svg viewBox="0 0 35 35" width="35" height="35" fill="#015cda" xmlns="http://www.w3.org/2000/svg" style={{ width: "100px", height: "100px", opacity: 0.5 }}>
    <defs>
      <symbol viewBox="0 0 18 18" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="deployment" data-type="15">
        <g>
          <title />
          <path fill="#76bc2d" d="M13.067 2.794v4.791L8.926 9.993V5.194l4.141-2.4z" />
          <path fill="#b4ec36" d="M13.067 2.794 8.926 5.201 4.785 2.793 8.926.386l4.141 2.408z" />
          <path fill="#86d633" d="M8.926 5.201v4.792L4.785 7.585V2.793l4.141 2.408z" />
          <path fill="#76bc2d" d="M8.782 10.416v4.791l-4.141 2.407v-4.798l4.141-2.4z" />
          <path fill="#b4ec36" d="m8.782 10.416-4.141 2.406L.5 10.415l4.141-2.408 4.141 2.409z" />
          <path fill="#86d633" d="M4.641 12.822v4.792L.5 15.207v-4.792l4.141 2.407z" />
          <path fill="#76bc2d" d="M17.5 10.416v4.791l-4.141 2.407v-4.798l4.141-2.4z" />
          <path fill="#b4ec36" d="m17.5 10.416-4.14 2.406-4.142-2.407 4.142-2.408 4.14 2.409z" />
          <path fill="#86d633" d="M13.359 12.822v4.792l-4.141-2.407v-4.792l4.141 2.407z" />
        </g>
      </symbol>
    </defs>
    <use href="#deployment" />
  </svg>
);

export const DeleteIconSvg = (
  <svg viewBox="0 0 16 16" width="16" height="16" fill="#015cda" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" role="presentation" focusable="false" id="FxSymbol0-067" data-type="1">
        <g>
          <title />
          <path fillRule="evenodd" d="M15.199 22H9.337c-.8 0-4.297-.18-4.337-1V7h14v14c-.04.82-3.001 1-3.801 1zm-8.217-8.629 3.143 3.809-1.159 1.304-3.143-3.809 1.076-1.304h.083zm10.123-3.855 1.072 1.304-6.407 7.664-3.143-3.809 1.159-1.304 2.026 2.456 5.209-6.311h.084zm-1.732 1.304-3.6 4.266-1.076-1.304 3.601-4.266 1.075 1.304zM19.346 6H4.654C4.101 6 4 5.77 4 5.5S4.101 4 4.654 4h14.692C19.899 4 20 5.23 20 5.5s-.101.5-.654.5zm-5.493-3h-3.757c-.402 0-.597-.13-.597-.5.011-.36.149-.5.597-.5h3.686c.402 0 .717.14.717.5 0 .37-.256.5-.646.5z" clipRule="evenodd" />
        </g>
      </symbol>
    </defs>
    <use href="#FxSymbol0-067" />
  </svg>
);

export const punchOutIconSvg = (
  <svg viewBox="0 0 16 15" width="12" height="12" fill="#015cda" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <symbol viewBox="0 0 16 15" role="presentation" focusable="false" xmlnsXlink="http://www.w3.org/1999/xlink" id="FxSymbol0-046" data-type="31">
        <g>
          <title />
          <path d="M14.3 1H10V0h6v6h-1V1.7l-8 8-.7-.7z" />
          <path d="M11 8v5a.9.9 0 0 1-1 1H2a.9.9 0 0 1-1-1V6a.9.9 0 0 1 1-1h6l1-1H2a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7z" />
        </g>
      </symbol>
    </defs>
    <use href="#FxSymbol0-046" />
  </svg>
);

export const DeleteIconDisabledSvg = (
  <svg viewBox="0 0 16 16" width="16" height="16" fill="#a19f9d" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" role="presentation" focusable="false" id="FxSymbol0-067" data-type="1">
        <g>
          <title />
          <path fillRule="evenodd" d="M15.199 22H9.337c-.8 0-4.297-.18-4.337-1V7h14v14c-.04.82-3.001 1-3.801 1zm-8.217-8.629 3.143 3.809-1.159 1.304-3.143-3.809 1.076-1.304h.083zm10.123-3.855 1.072 1.304-6.407 7.664-3.143-3.809 1.159-1.304 2.026 2.456 5.209-6.311h.084zm-1.732 1.304-3.6 4.266-1.076-1.304 3.601-4.266 1.075 1.304zM19.346 6H4.654C4.101 6 4 5.77 4 5.5S4.101 4 4.654 4h14.692C19.899 4 20 5.23 20 5.5s-.101.5-.654.5zm-5.493-3h-3.757c-.402 0-.597-.13-.597-.5.011-.36.149-.5.597-.5h3.686c.402 0 .717.14.717.5 0 .37-.256.5-.646.5z" clipRule="evenodd" />
        </g>
      </symbol>
    </defs>
    <use href="#FxSymbol0-067" />
  </svg>
);

const DatabaseSvg = (
  <svg viewBox="0 0 18 18" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg">
    <linearGradient id="db-a" x1="-.545" x2="12.955" y1="13.235" y2="13.235" gradientTransform="rotate(.147 1179.289 1099.97)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#005ba1" />
      <stop offset=".068" stopColor="#0060a9" />
      <stop offset=".356" stopColor="#0071c8" />
      <stop offset=".82" stopColor="#006abb" />
      <stop offset="1" stopColor="#005ba1" />
    </linearGradient>
    <path fill="url(#db-a)" d="M9.01 4.918C5.283 4.909 2.263 3.8 2.267 2.442l-.034 13.081C2.23 16.87 5.2 17.972 8.884 18h.093c3.728.009 6.753-1.084 6.756-2.442l.034-13.082c-.004 1.359-3.029 2.452-6.757 2.442z" />
    <path fill="#e6e6e6" d="M15.767 2.476c0 1.359-3.029 2.452-6.757 2.442S2.263 3.8 2.267 2.442 5.3-.01 9.023 0s6.747 1.118 6.744 2.476" />
    <path fill="#50e6ff" d="M14.191 2.273c0 .864-2.32 1.558-5.178 1.55s-5.172-.713-5.17-1.576S6.164.689 9.021.7s5.173.714 5.17 1.577" />
    <path fill="#198ab3" d="M9.016 2.62a12.442 12.442 0 0 0-4.1.583 12.014 12.014 0 0 0 4.1.62 12.037 12.037 0 0 0 4.1-.6 12.433 12.433 0 0 0-4.1-.603z" />
    <path fill="#f2f2f2" d="M4.475 13.225V8.063H6.3q2.749 0 2.749 2.516a2.546 2.546 0 0 1-.75 1.926 2.766 2.766 0 0 1-2 .72zM5.638 9.01v3.272h.576a1.559 1.559 0 0 0 1.186-.454 1.723 1.723 0 0 0 .43-1.234 1.563 1.563 0 0 0-.43-1.161 1.625 1.625 0 0 0-1.2-.423zm4.272 4.215V8.063h1.879a2.348 2.348 0 0 1 1.328.317 1.018 1.018 0 0 1 .464.893A1.055 1.055 0 0 1 13.3 10a1.489 1.489 0 0 1-.722.436v.014a1.429 1.429 0 0 1 .88.407 1.134 1.134 0 0 1 .329.824 1.378 1.378 0 0 1-.507 1.125 2.124 2.124 0 0 1-1.386.416zm1.163-4.3v1.224h.511a.854.854 0 0 0 .567-.175.593.593 0 0 0 .207-.48q0-.57-.85-.569zm0 2.087v1.361h.627a.968.968 0 0 0 .632-.187.624.624 0 0 0 .229-.511.582.582 0 0 0-.225-.486.994.994 0 0 0-.628-.177z" />
  </svg>
);

const AutonomousDatabaseSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 35 35">
    <defs>
      <linearGradient id="linear-gradient" x1="16.648" y1="18.718" x2="16.648" y2="4.488" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset="0.16" stopColor="#1380da" />
        <stop offset="0.53" stopColor="#3c91e5" />
        <stop offset="0.82" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
      <linearGradient id="linear-gradient-2" x1="16.915" y1="30.512" x2="16.915" y2="15.058" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="0.8" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="linear-gradient-3" x1="16.915" y1="30.512" x2="16.915" y2="15.058" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="1" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="linear-gradient-4" x1="16.915" y1="17.576" x2="16.915" y2="12.763" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b4b4" />
        <stop offset="0.33" stopColor="#b3b4b4" />
        <stop offset="0.82" stopColor="#cccccb" />
        <stop offset="1" stopColor="#cccccb" />
      </linearGradient>
    </defs>
    <g>
      <g id="a5e980e2-fe6c-4b4b-bd88-a9c235de5a4d">
        <path d="M29.743,18.718l.218-.4A6.448,6.448,0,0,0,25.67,8.968a1.877,1.877,0,0,1-1.286-1A6.3,6.3,0,0,0,14.139,6.5a1.772,1.772,0,0,1-1.479.548,5.1,5.1,0,0,0-5.481,4.1,1.854,1.854,0,0,1-.961,1.281,6.7,6.7,0,0,0-3.591,5.466l-.062.827Z" fill="url(#linear-gradient)" />
        <path d="M25.022,28.1c0,.825-.872,1.434-2.665,1.864a24.3,24.3,0,0,1-5.439.545,24.565,24.565,0,0,1-5.444-.542c-1.794-.43-2.666-1.039-2.666-1.864V15.058H25.022Z" fill="url(#linear-gradient-2)" />
        <path d="M25.022,28.1c0,.825-.872,1.434-2.665,1.864a24.3,24.3,0,0,1-5.439.545,24.565,24.565,0,0,1-5.444-.542c-1.794-.43-2.666-1.039-2.666-1.864V15.058H25.022Z" fill="url(#linear-gradient-3)" />
        <path d="M8.808,15.171c0-.825.872-1.434,2.666-1.863a24.3,24.3,0,0,1,5.439-.545,24.636,24.636,0,0,1,5.444.541c1.793.43,2.665,1.039,2.665,1.864s-.872,1.434-2.665,1.864a24.31,24.31,0,0,1-5.439.544,24.57,24.57,0,0,1-5.444-.541C9.68,16.605,8.808,16,8.808,15.171Z" fill="url(#linear-gradient-4)" />
        <path d="M25.023,18.952a4.579,4.579,0,0,1-2.1,1.087,26,26,0,0,1-12.023,0,4.589,4.589,0,0,1-2.1-1.087v1.53a4.589,4.589,0,0,0,2.1,1.087,26,26,0,0,0,12.023-.005,4.579,4.579,0,0,0,2.1-1.087Z" opacity="0.15" />
        <path d="M25.023,23.809a4.579,4.579,0,0,1-2.1,1.087,26.023,26.023,0,0,1-12.023,0,4.579,4.579,0,0,1-2.1-1.088v1.53a4.579,4.579,0,0,0,2.1,1.088,26.023,26.023,0,0,0,12.023-.005,4.579,4.579,0,0,0,2.1-1.087Z" opacity="0.15" />
        <circle cx="25.635" cy="14.446" r="6.8" fill="#76bc2d" />
        <path d="M26.085,12.009h-.906l-1.274,4.423h.947l.212-.931h1.1l.214.931h.979Zm-.852,2.738.383-1.655.378,1.655Z" fill="#fff" />
        <path d="M21.4,14.152l-.835-.835-.65.65L21.85,15.9l1.932-1.932-.65-.65-.8.8a3.33,3.33,0,0,1,6.248-1.252l.671-.672a4.247,4.247,0,0,0-7.841,1.952Z" fill="#fff" />
        <path d="M31.355,14.925l-1.929-1.932-1.932,1.932.65.649.8-.8A3.33,3.33,0,0,1,22.7,16.023l-.671.672a4.247,4.247,0,0,0,7.841-1.952l.835.835Z" fill="#fff" />
      </g>
    </g>
  </svg>
);

const AutonomousDatabaseWatermarkSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 35 35" style={{ width: "100px", height: "100px", opacity: 0.5 }}>
    <defs>
      <linearGradient id="linear-gradient" x1="16.648" y1="18.718" x2="16.648" y2="4.488" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset="0.16" stopColor="#1380da" />
        <stop offset="0.53" stopColor="#3c91e5" />
        <stop offset="0.82" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
      <linearGradient id="linear-gradient-2" x1="16.915" y1="30.512" x2="16.915" y2="15.058" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="0.8" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="linear-gradient-3" x1="16.915" y1="30.512" x2="16.915" y2="15.058" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="1" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="linear-gradient-4" x1="16.915" y1="17.576" x2="16.915" y2="12.763" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b4b4" />
        <stop offset="0.33" stopColor="#b3b4b4" />
        <stop offset="0.82" stopColor="#cccccb" />
        <stop offset="1" stopColor="#cccccb" />
      </linearGradient>
    </defs>
    <g>
      <g id="a5e980e2-fe6c-4b4b-bd88-a9c235de5a4d">
        <path d="M29.743,18.718l.218-.4A6.448,6.448,0,0,0,25.67,8.968a1.877,1.877,0,0,1-1.286-1A6.3,6.3,0,0,0,14.139,6.5a1.772,1.772,0,0,1-1.479.548,5.1,5.1,0,0,0-5.481,4.1,1.854,1.854,0,0,1-.961,1.281,6.7,6.7,0,0,0-3.591,5.466l-.062.827Z" fill="url(#linear-gradient)" />
        <path d="M25.022,28.1c0,.825-.872,1.434-2.665,1.864a24.3,24.3,0,0,1-5.439.545,24.565,24.565,0,0,1-5.444-.542c-1.794-.43-2.666-1.039-2.666-1.864V15.058H25.022Z" fill="url(#linear-gradient-2)" />
        <path d="M25.022,28.1c0,.825-.872,1.434-2.665,1.864a24.3,24.3,0,0,1-5.439.545,24.565,24.565,0,0,1-5.444-.542c-1.794-.43-2.666-1.039-2.666-1.864V15.058H25.022Z" fill="url(#linear-gradient-3)" />
        <path d="M8.808,15.171c0-.825.872-1.434,2.666-1.863a24.3,24.3,0,0,1,5.439-.545,24.636,24.636,0,0,1,5.444.541c1.793.43,2.665,1.039,2.665,1.864s-.872,1.434-2.665,1.864a24.31,24.31,0,0,1-5.439.544,24.57,24.57,0,0,1-5.444-.541C9.68,16.605,8.808,16,8.808,15.171Z" fill="url(#linear-gradient-4)" />
        <path d="M25.023,18.952a4.579,4.579,0,0,1-2.1,1.087,26,26,0,0,1-12.023,0,4.589,4.589,0,0,1-2.1-1.087v1.53a4.589,4.589,0,0,0,2.1,1.087,26,26,0,0,0,12.023-.005,4.579,4.579,0,0,0,2.1-1.087Z" opacity="0.15" />
        <path d="M25.023,23.809a4.579,4.579,0,0,1-2.1,1.087,26.023,26.023,0,0,1-12.023,0,4.579,4.579,0,0,1-2.1-1.088v1.53a4.579,4.579,0,0,0,2.1,1.088,26.023,26.023,0,0,0,12.023-.005,4.579,4.579,0,0,0,2.1-1.087Z" opacity="0.15" />
        <circle cx="25.635" cy="14.446" r="6.8" fill="#76bc2d" />
        <path d="M26.085,12.009h-.906l-1.274,4.423h.947l.212-.931h1.1l.214.931h.979Zm-.852,2.738.383-1.655.378,1.655Z" fill="#fff" />
        <path d="M21.4,14.152l-.835-.835-.65.65L21.85,15.9l1.932-1.932-.65-.65-.8.8a3.33,3.33,0,0,1,6.248-1.252l.671-.672a4.247,4.247,0,0,0-7.841,1.952Z" fill="#fff" />
        <path d="M31.355,14.925l-1.929-1.932-1.932,1.932.65.649.8-.8A3.33,3.33,0,0,1,22.7,16.023l-.671.672a4.247,4.247,0,0,0,7.841-1.952l.835.835Z" fill="#fff" />
      </g>
    </g>
  </svg>
);

const ApexSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35">
    <defs>
      <linearGradient id="apex-linear-gradient" x1="17.5" y1="5.6" x2="17.5" y2="29.4" gradientTransform="translate(17.5 -7.249) rotate(45)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#ffd70f" />
        <stop offset="0.34" stopColor="#eeb309" />
        <stop offset="0.77" stopColor="#dc8c03" />
        <stop offset="1" stopColor="#d57d01" />
      </linearGradient>
      <linearGradient id="apex-linear-gradient-2" x1="18.455" y1="19.412" x2="15.588" y2="16.545" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#5e9624" />
        <stop offset="0.321" stopColor="#639d26" />
        <stop offset="0.794" stopColor="#6fb12a" />
        <stop offset="0.999" stopColor="#76bc2d" />
      </linearGradient>
      <linearGradient id="apex-linear-gradient-3" x1="25.193" y1="12.152" x2="25.193" y2="7.461" gradientTransform="translate(14.308 -14.94) rotate(44.989)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="1" stopColor="#e6e6e6" />
      </linearGradient>
    </defs>
    <g style={{ isolation: "isolate" }}>
      <rect x="14.736" y="3.129" width="5.527" height="28.742" rx="0.521" transform="translate(-7.249 17.5) rotate(-45)" fill="url(#apex-linear-gradient)" />
      <rect x="9.278" y="8.185" width="2.764" height="1.043" transform="translate(-3.034 10.088) rotate(-45)" opacity="0.2" style={{ mixBlendMode: "multiply" }} />
      <rect x="11.603" y="10.509" width="2.764" height="1.043" transform="translate(-3.997 12.412) rotate(-45)" opacity="0.2" style={{ mixBlendMode: "multiply" }} />
      <rect x="13.926" y="12.833" width="2.764" height="1.043" transform="translate(-4.959 14.736) rotate(-45)" opacity="0.2" style={{ mixBlendMode: "multiply" }} />
      <path d="M27.538,10.328l.963-.963A2.028,2.028,0,0,0,29.1,7.932h0a2.028,2.028,0,0,0-2.027-2.027h0a2.028,2.028,0,0,0-1.433.594l-.962.962" fill="#ce74b6" />
      <rect x="24.912" y="23.818" width="2.764" height="1.043" transform="translate(-9.509 25.722) rotate(-45)" opacity="0.2" style={{ mixBlendMode: "multiply" }} />
      <rect x="22.588" y="21.494" width="2.764" height="1.043" transform="translate(-8.547 23.397) rotate(-45)" opacity="0.2" style={{ mixBlendMode: "multiply" }} />
      <rect x="20.264" y="19.171" width="2.764" height="1.043" transform="translate(-7.584 21.074) rotate(-45)" opacity="0.2" style={{ mixBlendMode: "multiply" }} />
      <path d="M12.088,25.625a4.748,4.748,0,0,0,.578-.425L25.714,12.152,22.849,9.285l-13,13a4.7,4.7,0,0,0-.5.591L9.826,25.3Z" fill="url(#apex-linear-gradient-2)" />
      <rect x="23.904" y="7.78" width="2.579" height="4.053" transform="translate(0.442 20.682) rotate(-44.989)" fill="url(#apex-linear-gradient-3)" />
      <path d="M9.345,22.879a4.741,4.741,0,0,0-.4.665L6.426,28.7l5.1-2.664a4.738,4.738,0,0,0,.565-.415Z" fill="#e6cfb8" />
      <polygon points="7.478 26.552 6.426 28.704 8.551 27.593 7.478 26.552" opacity="0.4" style={{ mixBlendMode: "multiply" }} />
    </g>
  </svg>
);

const ApexWatermarkSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" style={{ width: "100px", height: "100px", opacity: 0.5 }}>
    <defs>
      <linearGradient id="apex-linear-gradient" x1="17.5" y1="5.6" x2="17.5" y2="29.4" gradientTransform="translate(17.5 -7.249) rotate(45)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#ffd70f" />
        <stop offset="0.34" stopColor="#eeb309" />
        <stop offset="0.77" stopColor="#dc8c03" />
        <stop offset="1" stopColor="#d57d01" />
      </linearGradient>
      <linearGradient id="apex-linear-gradient-2" x1="18.455" y1="19.412" x2="15.588" y2="16.545" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#5e9624" />
        <stop offset="0.321" stopColor="#639d26" />
        <stop offset="0.794" stopColor="#6fb12a" />
        <stop offset="0.999" stopColor="#76bc2d" />
      </linearGradient>
      <linearGradient id="apex-linear-gradient-3" x1="25.193" y1="12.152" x2="25.193" y2="7.461" gradientTransform="translate(14.308 -14.94) rotate(44.989)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="1" stopColor="#e6e6e6" />
      </linearGradient>
    </defs>
    <g style={{ isolation: "isolate" }}>
      <rect x="14.736" y="3.129" width="5.527" height="28.742" rx="0.521" transform="translate(-7.249 17.5) rotate(-45)" fill="url(#apex-linear-gradient)" />
      <rect x="9.278" y="8.185" width="2.764" height="1.043" transform="translate(-3.034 10.088) rotate(-45)" opacity="0.2" style={{ mixBlendMode: "multiply" }} />
      <rect x="11.603" y="10.509" width="2.764" height="1.043" transform="translate(-3.997 12.412) rotate(-45)" opacity="0.2" style={{ mixBlendMode: "multiply" }} />
      <rect x="13.926" y="12.833" width="2.764" height="1.043" transform="translate(-4.959 14.736) rotate(-45)" opacity="0.2" style={{ mixBlendMode: "multiply" }} />
      <path d="M27.538,10.328l.963-.963A2.028,2.028,0,0,0,29.1,7.932h0a2.028,2.028,0,0,0-2.027-2.027h0a2.028,2.028,0,0,0-1.433.594l-.962.962" fill="#ce74b6" />
      <rect x="24.912" y="23.818" width="2.764" height="1.043" transform="translate(-9.509 25.722) rotate(-45)" opacity="0.2" style={{ mixBlendMode: "multiply" }} />
      <rect x="22.588" y="21.494" width="2.764" height="1.043" transform="translate(-8.547 23.397) rotate(-45)" opacity="0.2" style={{ mixBlendMode: "multiply" }} />
      <rect x="20.264" y="19.171" width="2.764" height="1.043" transform="translate(-7.584 21.074) rotate(-45)" opacity="0.2" style={{ mixBlendMode: "multiply" }} />
      <path d="M12.088,25.625a4.748,4.748,0,0,0,.578-.425L25.714,12.152,22.849,9.285l-13,13a4.7,4.7,0,0,0-.5.591L9.826,25.3Z" fill="url(#apex-linear-gradient-2)" />
      <rect x="23.904" y="7.78" width="2.579" height="4.053" transform="translate(0.442 20.682) rotate(-44.989)" fill="url(#apex-linear-gradient-3)" />
      <path d="M9.345,22.879a4.741,4.741,0,0,0-.4.665L6.426,28.7l5.1-2.664a4.738,4.738,0,0,0,.565-.415Z" fill="#e6cfb8" />
      <polygon points="7.478 26.552 6.426 28.704 8.551 27.593 7.478 26.552" opacity="0.4" style={{ mixBlendMode: "multiply" }} />
    </g>
  </svg>
);

const ExadataOracleCloudSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 35 35">
    <defs>
      <linearGradient id="linear-gradient" x1="17.5" y1="13.636" x2="17.5" y2="2.2" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset="0.16" stopColor="#1380da" />
        <stop offset="0.53" stopColor="#3c91e5" />
        <stop offset="0.82" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
      <linearGradient id="linear-gradient-2" x1="17.998" y1="32.8" x2="17.998" y2="8.381" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="1" stopColor="#e6e6e6" />
      </linearGradient>
    </defs>
    <g>
      <g id="a5e980e2-fe6c-4b4b-bd88-a9c235de5a4d">
        <path d="M28.024,13.636l.175-.325A5.179,5.179,0,0,0,24.751,5.8,1.509,1.509,0,0,1,23.717,5a5.058,5.058,0,0,0-8.233-1.182,1.421,1.421,0,0,1-1.189.44,4.1,4.1,0,0,0-4.4,3.292,1.493,1.493,0,0,1-.773,1.03,5.387,5.387,0,0,0-2.886,4.392l-.049.665Z" fill="url(#linear-gradient)" />
        <rect x="11.971" y="8.381" width="12.055" height="24.419" fill="url(#linear-gradient-2)" />
        <rect x="14.135" y="10.545" width="7.728" height="1.236" opacity="0.2" />
        <rect x="14.135" y="12.708" width="7.728" height="1.236" opacity="0.2" />
        <rect x="14.135" y="14.872" width="7.728" height="1.236" opacity="0.2" />
        <polygon points="18.734 26.015 20.341 29.554 18.938 29.554 17.9 27.082 16.932 29.554 15.541 29.554 17.133 25.966 15.592 22.6 16.995 22.6 17.954 24.906 18.861 22.587 20.252 22.587 18.734 26.015" fill="#fff" />
      </g>
    </g>
  </svg>
);

const InfrastructureSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 35 35">
    <defs>
      <linearGradient id="linear-gradient" x1="22.033" y1="31.1" x2="22.033" y2="12.967" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset="0.16" stopColor="#1380da" />
        <stop offset="0.53" stopColor="#3c91e5" />
        <stop offset="0.82" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
    </defs>
    <g>
      <g>
        <g>
          <rect x="23.875" y="6.902" width="8.925" height="19.284" fill="#969696" />
          <rect x="2.2" y="6.902" width="8.925" height="19.284" fill="#969696" />
          <rect x="11.125" y="3.714" width="12.75" height="27.572" fill="url(#linear-gradient)" />
          <path d="M9.616,10.408H3.879V9.133H9.616Zm0,2.55H3.879V11.683H9.616ZM3.879,22.68H9.616v1.275H3.879Zm5.737-1.913H3.879V19.492H9.616Zm0-6.853H3.879v4.622H9.616ZM8.341,17.261H5.154V15.189H8.341Z" opacity="0.25" />
          <path d="M25.384,9.133h5.737v1.275H25.384Zm0,2.55h5.737v1.275H25.384Zm5.737,12.272H25.384V22.68h5.737Zm-5.737-4.463h5.737v1.275H25.384Zm0-.956h5.737V13.914H25.384Zm1.275-3.347h3.187v2.072H26.659Z" opacity="0.25" />
          <path d="M20.528,10.408V9.133H14.472v1.275H13.356v1.275h1.116v1.275h6.056V11.683h1.116V10.408Zm-1.275,1.275H15.747V10.408h3.506Z" opacity="0.25" />
          <rect x="13.356" y="6.902" width="8.287" height="1.275" opacity="0.25" />
          <rect x="13.356" y="24.911" width="8.287" height="1.275" opacity="0.25" />
          <rect x="13.356" y="27.142" width="8.287" height="1.275" opacity="0.25" />
          <path d="M13.356,19.492v4.463h8.288V19.492Zm7.013,3.188H14.631V20.767h5.738Z" opacity="0.25" />
          <path d="M13.356,13.914v4.622h8.288V13.914Zm7.013,3.347H14.631V15.189h5.738Z" opacity="0.25" />
        </g>
      </g>
    </g>
  </svg>
);

const InfrastructureWatermarkSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 35 35" style={{ width: "100px", height: "100px", opacity: 0.5 }}>
    <defs>
      <linearGradient id="linear-gradient" x1="22.033" y1="31.1" x2="22.033" y2="12.967" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset="0.16" stopColor="#1380da" />
        <stop offset="0.53" stopColor="#3c91e5" />
        <stop offset="0.82" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
    </defs>
    <g>
      <g>
        <g>
          <rect x="23.875" y="6.902" width="8.925" height="19.284" fill="#969696" />
          <rect x="2.2" y="6.902" width="8.925" height="19.284" fill="#969696" />
          <rect x="11.125" y="3.714" width="12.75" height="27.572" fill="url(#linear-gradient)" />
          <path d="M9.616,10.408H3.879V9.133H9.616Zm0,2.55H3.879V11.683H9.616ZM3.879,22.68H9.616v1.275H3.879Zm5.737-1.913H3.879V19.492H9.616Zm0-6.853H3.879v4.622H9.616ZM8.341,17.261H5.154V15.189H8.341Z" opacity="0.25" />
          <path d="M25.384,9.133h5.737v1.275H25.384Zm0,2.55h5.737v1.275H25.384Zm5.737,12.272H25.384V22.68h5.737Zm-5.737-4.463h5.737v1.275H25.384Zm0-.956h5.737V13.914H25.384Zm1.275-3.347h3.187v2.072H26.659Z" opacity="0.25" />
          <path d="M20.528,10.408V9.133H14.472v1.275H13.356v1.275h1.116v1.275h6.056V11.683h1.116V10.408Zm-1.275,1.275H15.747V10.408h3.506Z" opacity="0.25" />
          <rect x="13.356" y="6.902" width="8.287" height="1.275" opacity="0.25" />
          <rect x="13.356" y="24.911" width="8.287" height="1.275" opacity="0.25" />
          <rect x="13.356" y="27.142" width="8.287" height="1.275" opacity="0.25" />
          <path d="M13.356,19.492v4.463h8.288V19.492Zm7.013,3.188H14.631V20.767h5.738Z" opacity="0.25" />
          <path d="M13.356,13.914v4.622h8.288V13.914Zm7.013,3.347H14.631V15.189h5.738Z" opacity="0.25" />
        </g>
      </g>
    </g>
  </svg>
);

const VmClusterNewSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 35 35">
    <defs>
      <linearGradient id="linear-gradient" x1="22.033" y1="31.1" x2="22.033" y2="12.967" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset="0.16" stopColor="#1380da" />
        <stop offset="0.53" stopColor="#3c91e5" />
        <stop offset="0.82" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
    </defs>
    <rect x="3.9" y="3.9" width="18.133" height="18.133" rx="2.267" fill="#005ba1" />
    <rect x="8.433" y="8.433" width="18.133" height="18.133" rx="2.267" fill="#0078d4" />
    <rect x="12.967" y="12.967" width="18.133" height="18.133" rx="2.267" fill="url(#linear-gradient)" />
    <g>
      <path d="M17.713,25.66l-2.035-7.253h1.6l1.238,5.418,1.237-5.418h1.566L19.28,25.66Z" fill="#fff" />
      <path d="M21.993,25.66V18.407H23.62l1.6,4.23,1.586-4.23h1.586V25.66H26.982V21.121l-1.407,3.741h-.768L23.4,21.121V25.66Z" fill="#fff" />
    </g>
  </svg>
);

const VmClusterWatermarkNewSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 35 35" style={{ width: "100px", height: "100px", opacity: 0.5 }}>
    <defs>
      <linearGradient id="linear-gradient" x1="22.033" y1="31.1" x2="22.033" y2="12.967" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset="0.16" stopColor="#1380da" />
        <stop offset="0.53" stopColor="#3c91e5" />
        <stop offset="0.82" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
    </defs>
    <rect x="3.9" y="3.9" width="18.133" height="18.133" rx="2.267" fill="#005ba1" />
    <rect x="8.433" y="8.433" width="18.133" height="18.133" rx="2.267" fill="#0078d4" />
    <rect x="12.967" y="12.967" width="18.133" height="18.133" rx="2.267" fill="url(#linear-gradient)" />
    <g>
      <path d="M17.713,25.66l-2.035-7.253h1.6l1.238,5.418,1.237-5.418h1.566L19.28,25.66Z" fill="#fff" />
      <path d="M21.993,25.66V18.407H23.62l1.6,4.23,1.586-4.23h1.586V25.66H26.982V21.121l-1.407,3.741h-.768L23.4,21.121V25.66Z" fill="#fff" />
    </g>
  </svg>
);

const DatabaseHomeSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 35 35">
    <defs>
      <linearGradient id="dbhome-linear-gradient-01" x1="13.25" y1="24.37" x2="13.25" y2="6.547" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="0.8" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="dbhome-linear-gradient-02" x1="13.25" y1="24.37" x2="13.25" y2="6.547" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="1" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="dbhome-linear-gradient-03" x1="13.25" y1="9.452" x2="13.25" y2="3.9" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b4b4" />
        <stop offset="0.33" stopColor="#b3b4b4" />
        <stop offset="0.82" stopColor="#cccccb" />
        <stop offset="1" stopColor="#cccccb" />
      </linearGradient>
      <linearGradient id="dbhome-linear-gradient-04" x1="24.3" y1="31.1" x2="24.3" y2="17.5" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset="0.16" stopColor="#1380da" />
        <stop offset="0.53" stopColor="#3c91e5" />
        <stop offset="0.82" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
    </defs>
    <g>
      <g id="a5e980e2-fe6c-4b4b-bd88-a9c235de5a4d">
        <g>
          <path d="M22.6,21.592c0,.951-1.006,1.654-3.074,2.15a28.033,28.033,0,0,1-6.273.628,28.315,28.315,0,0,1-6.279-.625c-2.068-.5-3.074-1.2-3.074-2.149V6.547H22.6Z" fill="url(#dbhome-linear-gradient-01)" />
          <path d="M22.6,21.592c0,.951-1.006,1.654-3.074,2.15a28.033,28.033,0,0,1-6.273.628,28.315,28.315,0,0,1-6.279-.625c-2.068-.5-3.074-1.2-3.074-2.149V6.547H22.6Z" fill="url(#dbhome-linear-gradient-02)" />
          <path d="M3.9,6.678c0-.952,1.006-1.654,3.074-2.15A28.027,28.027,0,0,1,13.247,3.9a28.315,28.315,0,0,1,6.279.625c2.068.5,3.074,1.2,3.074,2.149s-1.006,1.653-3.074,2.149a28.028,28.028,0,0,1-6.273.629,28.375,28.375,0,0,1-6.279-.625C4.906,8.331,3.9,7.629,3.9,6.678Z" fill="url(#dbhome-linear-gradient-03)" />
          <path d="M22.6,11.039a5.293,5.293,0,0,1-2.417,1.253A30,30,0,0,1,6.316,12.3,5.283,5.283,0,0,1,3.9,11.043v1.765a5.284,5.284,0,0,0,2.416,1.254,30.012,30.012,0,0,0,13.867,0A5.283,5.283,0,0,0,22.6,12.8Z" opacity="0.15" />
          <path d="M22.6,16.64a5.283,5.283,0,0,1-2.417,1.253A30,30,0,0,1,6.316,17.9,5.284,5.284,0,0,1,3.9,16.645v1.764a5.283,5.283,0,0,0,2.416,1.255,30,30,0,0,0,13.867-.006A5.283,5.283,0,0,0,22.6,18.4Z" opacity="0.15" />
        </g>
        <rect x="17.5" y="17.5" width="13.6" height="13.6" rx="1.7" fill="url(#dbhome-linear-gradient-04)" />
        <polygon points="24.3 20.645 22.317 22.723 22.317 21.779 21.637 21.779 21.637 23.435 20.9 24.207 20.9 27.955 23.167 27.955 23.167 25.065 25.433 25.065 25.433 27.955 27.7 27.955 27.7 24.207 24.3 20.645" fill="#fff" />
      </g>
    </g>
  </svg>
);

const DbSystemSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35">
    <defs>
      <linearGradient id="dbsys-linear-gradient-01" x1="13.25" y1="23.962" x2="13.25" y2="6.139" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="0.8" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="dbsys-linear-gradient-02" x1="13.25" y1="23.962" x2="13.25" y2="6.139" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="1" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="dbsys-linear-gradient-03" x1="13.25" y1="9.044" x2="13.25" y2="3.492" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b4b4" />
        <stop offset="0.33" stopColor="#b3b4b4" />
        <stop offset="0.82" stopColor="#cccccb" />
        <stop offset="1" stopColor="#cccccb" />
      </linearGradient>
      <linearGradient id="dbsys-linear-gradient-04" x1="24.3" y1="30.692" x2="24.3" y2="17.092" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset="0.16" stopColor="#1380da" />
        <stop offset="0.53" stopColor="#3c91e5" />
        <stop offset="0.82" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
    </defs>
    <g style={{ isolation: "isolate" }}>
      <g id="a5e980e2-fe6c-4b4b-bd88-a9c235de5a4d">
        <g>
          <path d="M22.6,21.184c0,.951-1.006,1.654-3.074,2.15a28.033,28.033,0,0,1-6.273.628,28.315,28.315,0,0,1-6.279-.625c-2.068-.5-3.074-1.2-3.074-2.149V6.139H22.6Z" fill="url(#dbsys-linear-gradient-01)" />
          <path d="M22.6,21.184c0,.951-1.006,1.654-3.074,2.15a28.033,28.033,0,0,1-6.273.628,28.315,28.315,0,0,1-6.279-.625c-2.068-.5-3.074-1.2-3.074-2.149V6.139H22.6Z" fill="url(#dbsys-linear-gradient-02)" />
          <path d="M3.9,6.27c0-.952,1.006-1.654,3.074-2.15a28.027,28.027,0,0,1,6.273-.628,28.315,28.315,0,0,1,6.279.625c2.068.5,3.074,1.2,3.074,2.149s-1.006,1.653-3.074,2.149a28.028,28.028,0,0,1-6.273.629,28.375,28.375,0,0,1-6.279-.625C4.906,7.923,3.9,7.221,3.9,6.27Z" fill="url(#dbsys-linear-gradient-03)" />
          <path d="M22.6,10.631a5.293,5.293,0,0,1-2.417,1.253,30,30,0,0,1-13.867.006A5.283,5.283,0,0,1,3.9,10.635V12.4a5.284,5.284,0,0,0,2.416,1.254,30.012,30.012,0,0,0,13.867-.005A5.283,5.283,0,0,0,22.6,12.4Z" opacity="0.15" style={{ mixBlendMode: "multiply" }} />
          <path d="M22.6,16.232a5.283,5.283,0,0,1-2.417,1.253,30,30,0,0,1-13.867.006A5.284,5.284,0,0,1,3.9,16.237V18a5.283,5.283,0,0,0,2.416,1.255,30,30,0,0,0,13.867-.006A5.283,5.283,0,0,0,22.6,18Z" opacity="0.15" style={{ mixBlendMode: "multiply" }} />
        </g>
        <rect x="17.5" y="17.092" width="13.6" height="13.6" rx="1" fill="url(#dbsys-linear-gradient-04)" />
        <g id="b33a10b5-62f7-4935-ba61-5887e2c71eb8">
          <path d="M28.414,24.266v-.952h0l-.969-.34-.238-.646.476-1v-.1l-.306-.306-.357-.408h-.136l-.952.51-.646-.187-.425-1.071h-.935l-.323.969-.714.289-1.105-.527-.663.663v.119l.493.952-.289.714-1.139.425v.952h.136l1,.34.272.646-.51,1.105.663.68h.136l.935-.476.663.272.408,1.139h.952v-.136l.323-1.02.646-.272,1.122.527.663-.663v-.136l-.476-.952.187-.663Zm-4.189.961a1.343,1.343,0,0,1,0-2.669,1.324,1.324,0,0,1,1.342,1.308.109.109,0,0,1,0,.018h0a1.327,1.327,0,0,1-1.309,1.343Z" fill="#fff" />
        </g>
      </g>
    </g>
  </svg>
);

const BaseDatabaseSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 35 35">
    <defs>
      <linearGradient id="linear-gradient" x1="16.648" y1="18.718" x2="16.648" y2="4.488" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset="0.16" stopColor="#1380da" />
        <stop offset="0.53" stopColor="#3c91e5" />
        <stop offset="0.82" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
      <linearGradient id="linear-gradient-2" x1="16.915" y1="30.512" x2="16.915" y2="15.058" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="0.8" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="linear-gradient-3" x1="16.915" y1="30.512" x2="16.915" y2="15.058" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="1" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="linear-gradient-4" x1="16.915" y1="17.576" x2="16.915" y2="12.763" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b4b4" />
        <stop offset="0.33" stopColor="#b3b4b4" />
        <stop offset="0.82" stopColor="#cccccb" />
        <stop offset="1" stopColor="#cccccb" />
      </linearGradient>
    </defs>
    <g>
      <g id="a5e980e2-fe6c-4b4b-bd88-a9c235de5a4d">
        <path d="M29.743,18.718l.218-.4A6.448,6.448,0,0,0,25.67,8.968a1.877,1.877,0,0,1-1.286-1A6.3,6.3,0,0,0,14.139,6.5a1.772,1.772,0,0,1-1.479.548,5.1,5.1,0,0,0-5.481,4.1,1.854,1.854,0,0,1-.961,1.281,6.7,6.7,0,0,0-3.591,5.466l-.062.827Z" fill="url(#linear-gradient)" />
        <path d="M25.022,28.1c0,.825-.872,1.434-2.665,1.864a24.3,24.3,0,0,1-5.439.545,24.565,24.565,0,0,1-5.444-.542c-1.794-.43-2.666-1.039-2.666-1.864V15.058H25.022Z" fill="url(#linear-gradient-2)" />
        <path d="M25.022,28.1c0,.825-.872,1.434-2.665,1.864a24.3,24.3,0,0,1-5.439.545,24.565,24.565,0,0,1-5.444-.542c-1.794-.43-2.666-1.039-2.666-1.864V15.058H25.022Z" fill="url(#linear-gradient-3)" />
        <path d="M8.808,15.171c0-.825.872-1.434,2.666-1.863a24.3,24.3,0,0,1,5.439-.545,24.636,24.636,0,0,1,5.444.541c1.793.43,2.665,1.039,2.665,1.864s-.872,1.434-2.665,1.864a24.31,24.31,0,0,1-5.439.544,24.57,24.57,0,0,1-5.444-.541C9.68,16.605,8.808,16,8.808,15.171Z" fill="url(#linear-gradient-4)" />
        <path d="M25.023,18.952a4.579,4.579,0,0,1-2.1,1.087,26,26,0,0,1-12.023,0,4.589,4.589,0,0,1-2.1-1.087v1.53a4.589,4.589,0,0,0,2.1,1.087,26,26,0,0,0,12.023-.005,4.579,4.579,0,0,0,2.1-1.087Z" opacity="0.15" />
        <path d="M25.023,23.809a4.579,4.579,0,0,1-2.1,1.087,26.023,26.023,0,0,1-12.023,0,4.579,4.579,0,0,1-2.1-1.088v1.53a4.579,4.579,0,0,0,2.1,1.088,26.023,26.023,0,0,0,12.023-.005,4.579,4.579,0,0,0,2.1-1.087Z" opacity="0.15" />
      </g>
    </g>
  </svg>
);

const BaseDatabaseWatermarkSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 35 35" style={{ width: "100px", height: "100px", opacity: 0.5 }}>
    <defs>
      <linearGradient id="linear-gradient" x1="16.648" y1="18.718" x2="16.648" y2="4.488" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset="0.16" stopColor="#1380da" />
        <stop offset="0.53" stopColor="#3c91e5" />
        <stop offset="0.82" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
      <linearGradient id="linear-gradient-2" x1="16.915" y1="30.512" x2="16.915" y2="15.058" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="0.8" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="linear-gradient-3" x1="16.915" y1="30.512" x2="16.915" y2="15.058" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="1" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="linear-gradient-4" x1="16.915" y1="17.576" x2="16.915" y2="12.763" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b4b4" />
        <stop offset="0.33" stopColor="#b3b4b4" />
        <stop offset="0.82" stopColor="#cccccb" />
        <stop offset="1" stopColor="#cccccb" />
      </linearGradient>
    </defs>
    <g>
      <g id="a5e980e2-fe6c-4b4b-bd88-a9c235de5a4d">
        <path d="M29.743,18.718l.218-.4A6.448,6.448,0,0,0,25.67,8.968a1.877,1.877,0,0,1-1.286-1A6.3,6.3,0,0,0,14.139,6.5a1.772,1.772,0,0,1-1.479.548,5.1,5.1,0,0,0-5.481,4.1,1.854,1.854,0,0,1-.961,1.281,6.7,6.7,0,0,0-3.591,5.466l-.062.827Z" fill="url(#linear-gradient)" />
        <path d="M25.022,28.1c0,.825-.872,1.434-2.665,1.864a24.3,24.3,0,0,1-5.439.545,24.565,24.565,0,0,1-5.444-.542c-1.794-.43-2.666-1.039-2.666-1.864V15.058H25.022Z" fill="url(#linear-gradient-2)" />
        <path d="M25.022,28.1c0,.825-.872,1.434-2.665,1.864a24.3,24.3,0,0,1-5.439.545,24.565,24.565,0,0,1-5.444-.542c-1.794-.43-2.666-1.039-2.666-1.864V15.058H25.022Z" fill="url(#linear-gradient-3)" />
        <path d="M8.808,15.171c0-.825.872-1.434,2.666-1.863a24.3,24.3,0,0,1,5.439-.545,24.636,24.636,0,0,1,5.444.541c1.793.43,2.665,1.039,2.665,1.864s-.872,1.434-2.665,1.864a24.31,24.31,0,0,1-5.439.544,24.57,24.57,0,0,1-5.444-.541C9.68,16.605,8.808,16,8.808,15.171Z" fill="url(#linear-gradient-4)" />
        <path d="M25.023,18.952a4.579,4.579,0,0,1-2.1,1.087,26,26,0,0,1-12.023,0,4.589,4.589,0,0,1-2.1-1.087v1.53a4.589,4.589,0,0,0,2.1,1.087,26,26,0,0,0,12.023-.005,4.579,4.579,0,0,0,2.1-1.087Z" opacity="0.15" />
        <path d="M25.023,23.809a4.579,4.579,0,0,1-2.1,1.087,26.023,26.023,0,0,1-12.023,0,4.579,4.579,0,0,1-2.1-1.088v1.53a4.579,4.579,0,0,0,2.1,1.088,26.023,26.023,0,0,0,12.023-.005,4.579,4.579,0,0,0,2.1-1.087Z" opacity="0.15" />
      </g>
    </g>
  </svg>
);

const MysqlSvg = (
  <svg width="35" height="35" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="paint0_linear_1012_1183" x1="14.3684" y1="30.2263" x2="14.3684" y2="8.46802" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B3B3B3" />
        <stop offset="0.8" stopColor="#E6E6E6" />
      </linearGradient>
      <linearGradient id="paint1_linear_1012_1183" x1="14.3684" y1="30.2263" x2="14.3684" y2="8.46802" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1380DA" />
        <stop offset="1" stopColor="#559CEC" />
      </linearGradient>
      <linearGradient id="paint2_linear_1012_1183" x1="247.249" y1="65.9217" x2="247.249" y2="31.688" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1380DA" />
        <stop offset="1" stopColor="#559CEC" />
      </linearGradient>
      <linearGradient id="paint3_linear_1012_1183" x1="575.955" y1="696.654" x2="575.955" y2="344.124" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B3B3B3" />
        <stop offset="0.8" stopColor="#E6E6E6" />
      </linearGradient>
      <linearGradient id="paint4_linear_1012_1183" x1="32.631" y1="41.7628" x2="32.631" y2="20.0045" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B3B3B3" />
        <stop offset="1" stopColor="#E6E6E6" />
      </linearGradient>
      <linearGradient id="paint5_linear_1012_1183" x1="32.6311" y1="23.5509" x2="32.6311" y2="16.7735" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B3B4B4" />
        <stop offset="0.33" stopColor="#B3B4B4" />
        <stop offset="0.82" stopColor="#CCCCCB" />
        <stop offset="1" stopColor="#CCCCCB" />
      </linearGradient>
    </defs>
    <path d="M25.7827 26.8356C25.7827 27.9972 24.5553 28.8499 22.0294 29.4596C19.5149 30.002 16.9472 30.2592 14.3751 30.2263C11.801 30.2581 9.23141 30.0023 6.7141 29.4636C4.18147 28.858 2.9541 28.0012 2.9541 26.8396V8.46802H25.7827V26.8356Z" fill="url(#paint0_linear_1012_1183)" />
    <path d="M25.7827 26.8356C25.7827 27.9972 24.5553 28.8499 22.0294 29.4596C19.5149 30.002 16.9472 30.2592 14.3751 30.2263C11.801 30.2581 9.23141 30.0023 6.7141 29.4636C4.18147 28.858 2.9541 28.0012 2.9541 26.8396V8.46802H25.7827V26.8356Z" fill="url(#paint1_linear_1012_1183)" />
    <path d="M2.9541 8.62788C2.9541 7.46631 4.18147 6.6136 6.7141 6.00394C9.22861 5.46153 11.7963 5.20431 14.3684 5.23717C16.9434 5.20519 19.5139 5.46103 22.0321 5.99991C24.558 6.60554 25.7854 7.46228 25.7854 8.62385C25.7854 9.78542 24.558 10.6381 22.0321 11.2478C19.5176 11.7902 16.9499 12.0474 14.3778 12.0146C11.8028 12.0465 9.23228 11.7907 6.7141 11.2518C4.18147 10.6462 2.9541 9.78945 2.9541 8.62788Z" fill="url(#paint2_linear_1012_1183)" />
    <g style={{ mixBlendMode: "multiply" }} opacity="0.15">
      <path d="M25.7827 13.9524C24.9483 14.7114 23.9298 15.2388 22.8284 15.4819C17.2663 16.8051 11.4716 16.8074 5.90839 15.4886C4.80632 15.2465 3.78741 14.7185 2.9541 13.9578V16.1144C3.78776 16.8749 4.80648 17.4033 5.90839 17.6466C11.472 18.9634 17.2665 18.9597 22.8284 17.6359C23.93 17.3933 24.9487 16.8659 25.7827 16.1063V13.9524Z" fill="black" />
    </g>
    <g style={{ mixBlendMode: "multiply" }} opacity="0.15">
      <path d="M25.7827 20.79C24.9483 21.5491 23.9298 22.0764 22.8284 22.3196C17.2663 23.6425 11.4717 23.6453 5.90839 22.3276C4.80648 22.0843 3.78776 21.5559 2.9541 20.7954V22.944C3.78776 23.7045 4.80648 24.2329 5.90839 24.4762C11.4713 25.7956 17.2659 25.7947 22.8284 24.4735C23.93 24.2309 24.9487 23.7035 25.7827 22.944V20.79Z" fill="black" />
    </g>
    <path d="M44.0452 38.3721C44.0452 39.5337 42.8179 40.3864 40.292 40.9961C37.7775 41.5385 35.2098 41.7957 32.6377 41.7628C30.0627 41.7948 27.4922 41.539 24.974 41.0001C22.4481 40.3945 21.2207 39.5377 21.2207 38.3761V20.0085H44.0493L44.0452 38.3721Z" fill="url(#paint3_linear_1012_1183)" />
    <path d="M44.0452 38.3721C44.0452 39.5337 42.8179 40.3864 40.292 40.9961C37.7775 41.5385 35.2098 41.7957 32.6377 41.7628C30.0627 41.7948 27.4922 41.539 24.974 41.0001C22.4481 40.3945 21.2207 39.5377 21.2207 38.3761V20.0085H44.0493L44.0452 38.3721Z" fill="url(#paint4_linear_1012_1183)" />
    <path d="M21.2168 20.1643C21.2168 19.0027 22.4442 18.15 24.9701 17.5403C27.4846 16.9979 30.0522 16.7407 32.6244 16.7735C35.1994 16.7416 37.7699 16.9974 40.2881 17.5363C42.814 18.1419 44.0413 18.9987 44.0413 20.1602C44.0413 21.3218 42.814 22.1745 40.2881 22.7842C37.7735 23.3266 35.2059 23.5838 32.6338 23.5509C30.061 23.5824 27.4928 23.3266 24.9768 22.7882C22.4442 22.1826 21.2168 21.3258 21.2168 20.1643Z" fill="url(#paint5_linear_1012_1183)" />
    <g style={{ mixBlendMode: "multiply" }} opacity="0.15">
      <path d="M44.0454 25.4888C43.211 26.2478 42.1925 26.7751 41.0911 27.0183C35.529 28.3413 29.7344 28.344 24.1711 27.0263C23.0692 26.783 22.0505 26.2547 21.2168 25.4941V27.6427C22.0499 28.4052 23.0686 28.9354 24.1711 29.1803C29.7344 30.498 35.529 30.4952 41.0911 29.1722C42.1927 28.9297 43.2114 28.4023 44.0454 27.6427V25.4888Z" fill="black" />
    </g>
    <g style={{ mixBlendMode: "multiply" }} opacity="0.15">
      <path d="M44.0454 32.3264C43.211 33.0855 42.1925 33.6128 41.0911 33.8559C35.529 35.1789 29.7344 35.1817 24.1711 33.864C23.0692 33.6207 22.0505 33.0923 21.2168 32.3318V34.4804C22.0499 35.2428 23.0686 35.7731 24.1711 36.0179C29.7344 37.3356 35.529 37.3329 41.0911 36.0099C42.1927 35.7673 43.2114 35.2399 44.0454 34.4804V32.3264Z" fill="black" />
    </g>
  </svg>
);

const MySQLWatermarkSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 47 47" style={{ width: "100px", height: "100px", opacity: 0.5 }}>
    <defs>
      <linearGradient id="paint0_linear_1012_1183" x1="14.3684" y1="30.2263" x2="14.3684" y2="8.46802" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B3B3B3" />
        <stop offset="0.8" stopColor="#E6E6E6" />
      </linearGradient>
      <linearGradient id="paint1_linear_1012_1183" x1="14.3684" y1="30.2263" x2="14.3684" y2="8.46802" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1380DA" />
        <stop offset="1" stopColor="#559CEC" />
      </linearGradient>
      <linearGradient id="paint2_linear_1012_1183" x1="247.249" y1="65.9217" x2="247.249" y2="31.688" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1380DA" />
        <stop offset="1" stopColor="#559CEC" />
      </linearGradient>
      <linearGradient id="paint3_linear_1012_1183" x1="575.955" y1="696.654" x2="575.955" y2="344.124" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B3B3B3" />
        <stop offset="0.8" stopColor="#E6E6E6" />
      </linearGradient>
      <linearGradient id="paint4_linear_1012_1183" x1="32.631" y1="41.7628" x2="32.631" y2="20.0045" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B3B3B3" />
        <stop offset="1" stopColor="#E6E6E6" />
      </linearGradient>
      <linearGradient id="paint5_linear_1012_1183" x1="32.6311" y1="23.5509" x2="32.6311" y2="16.7735" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B3B4B4" />
        <stop offset="0.33" stopColor="#B3B4B4" />
        <stop offset="0.82" stopColor="#CCCCCB" />
        <stop offset="1" stopColor="#CCCCCB" />
      </linearGradient>
    </defs>
    <path d="M25.7827 26.8356C25.7827 27.9972 24.5553 28.8499 22.0294 29.4596C19.5149 30.002 16.9472 30.2592 14.3751 30.2263C11.801 30.2581 9.23141 30.0023 6.7141 29.4636C4.18147 28.858 2.9541 28.0012 2.9541 26.8396V8.46802H25.7827V26.8356Z" fill="url(#paint0_linear_1012_1183)" />
    <path d="M25.7827 26.8356C25.7827 27.9972 24.5553 28.8499 22.0294 29.4596C19.5149 30.002 16.9472 30.2592 14.3751 30.2263C11.801 30.2581 9.23141 30.0023 6.7141 29.4636C4.18147 28.858 2.9541 28.0012 2.9541 26.8396V8.46802H25.7827V26.8356Z" fill="url(#paint1_linear_1012_1183)" />
    <path d="M2.9541 8.62788C2.9541 7.46631 4.18147 6.6136 6.7141 6.00394C9.22861 5.46153 11.7963 5.20431 14.3684 5.23717C16.9434 5.20519 19.5139 5.46103 22.0321 5.99991C24.558 6.60554 25.7854 7.46228 25.7854 8.62385C25.7854 9.78542 24.558 10.6381 22.0321 11.2478C19.5176 11.7902 16.9499 12.0474 14.3778 12.0146C11.8028 12.0465 9.23228 11.7907 6.7141 11.2518C4.18147 10.6462 2.9541 9.78945 2.9541 8.62788Z" fill="url(#paint2_linear_1012_1183)" />
    <g style={{ mixBlendMode: "multiply" }} opacity="0.15">
      <path d="M25.7827 13.9524C24.9483 14.7114 23.9298 15.2388 22.8284 15.4819C17.2663 16.8051 11.4716 16.8074 5.90839 15.4886C4.80632 15.2465 3.78741 14.7185 2.9541 13.9578V16.1144C3.78776 16.8749 4.80648 17.4033 5.90839 17.6466C11.472 18.9634 17.2665 18.9597 22.8284 17.6359C23.93 17.3933 24.9487 16.8659 25.7827 16.1063V13.9524Z" fill="black" />
    </g>
    <g style={{ mixBlendMode: "multiply" }} opacity="0.15">
      <path d="M25.7827 20.79C24.9483 21.5491 23.9298 22.0764 22.8284 22.3196C17.2663 23.6425 11.4717 23.6453 5.90839 22.3276C4.80648 22.0843 3.78776 21.5559 2.9541 20.7954V22.944C3.78776 23.7045 4.80648 24.2329 5.90839 24.4762C11.4713 25.7956 17.2659 25.7947 22.8284 24.4735C23.93 24.2309 24.9487 23.7035 25.7827 22.944V20.79Z" fill="black" />
    </g>
    <path d="M44.0452 38.3721C44.0452 39.5337 42.8179 40.3864 40.292 40.9961C37.7775 41.5385 35.2098 41.7957 32.6377 41.7628C30.0627 41.7948 27.4922 41.539 24.974 41.0001C22.4481 40.3945 21.2207 39.5377 21.2207 38.3761V20.0085H44.0493L44.0452 38.3721Z" fill="url(#paint3_linear_1012_1183)" />
    <path d="M44.0452 38.3721C44.0452 39.5337 42.8179 40.3864 40.292 40.9961C37.7775 41.5385 35.2098 41.7957 32.6377 41.7628C30.0627 41.7948 27.4922 41.539 24.974 41.0001C22.4481 40.3945 21.2207 39.5377 21.2207 38.3761V20.0085H44.0493L44.0452 38.3721Z" fill="url(#paint4_linear_1012_1183)" />
    <path d="M21.2168 20.1643C21.2168 19.0027 22.4442 18.15 24.9701 17.5403C27.4846 16.9979 30.0522 16.7407 32.6244 16.7735C35.1994 16.7416 37.7699 16.9974 40.2881 17.5363C42.814 18.1419 44.0413 18.9987 44.0413 20.1602C44.0413 21.3218 42.814 22.1745 40.2881 22.7842C37.7735 23.3266 35.2059 23.5838 32.6338 23.5509C30.061 23.5824 27.4928 23.3266 24.9768 22.7882C22.4442 22.1826 21.2168 21.3258 21.2168 20.1643Z" fill="url(#paint5_linear_1012_1183)" />
    <g style={{ mixBlendMode: "multiply" }} opacity="0.15">
      <path d="M44.0454 25.4888C43.211 26.2478 42.1925 26.7751 41.0911 27.0183C35.529 28.3413 29.7344 28.344 24.1711 27.0263C23.0692 26.783 22.0505 26.2547 21.2168 25.4941V27.6427C22.0499 28.4052 23.0686 28.9354 24.1711 29.1803C29.7344 30.498 35.529 30.4952 41.0911 29.1722C42.1927 28.9297 43.2114 28.4023 44.0454 27.6427V25.4888Z" fill="black" />
    </g>
    <g style={{ mixBlendMode: "multiply" }} opacity="0.15">
      <path d="M44.0454 32.3264C43.211 33.0855 42.1925 33.6128 41.0911 33.8559C35.529 35.1789 29.7344 35.1817 24.1711 33.864C23.0692 33.6207 22.0505 33.0923 21.2168 32.3318V34.4804C22.0499 35.2428 23.0686 35.7731 24.1711 36.0179C29.7344 37.3356 35.529 37.3329 41.0911 36.0099C42.1927 35.7673 43.2114 35.2399 44.0454 34.4804V32.3264Z" fill="black" />
    </g>
  </svg>
);

const AttachedDatabaseSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35">
    <defs>
      <linearGradient id="attached-db-linear-gradient" x1="13.25" y1="24.37" x2="13.25" y2="6.547" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="0.8" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="attached-db-linear-gradient-2" x1="13.25" y1="24.37" x2="13.25" y2="6.547" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="1" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="attached-db-linear-gradient-3" x1="13.25" y1="9.452" x2="13.25" y2="3.9" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b4b4" />
        <stop offset="0.33" stopColor="#b3b4b4" />
        <stop offset="0.82" stopColor="#cccccb" />
        <stop offset="1" stopColor="#cccccb" />
      </linearGradient>
      <linearGradient id="attached-db-linear-gradient-4" x1="24.3" y1="31.1" x2="24.3" y2="17.5" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset="0.16" stopColor="#1380da" />
        <stop offset="0.53" stopColor="#3c91e5" />
        <stop offset="0.82" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
    </defs>
    <g style={{ isolation: "isolate" }}>
      <g id="a5e980e2-fe6c-4b4b-bd88-a9c235de5a4d">
        <g>
          <path d="M22.6,21.592c0,.951-1.006,1.654-3.074,2.15a28.033,28.033,0,0,1-6.273.628,28.315,28.315,0,0,1-6.279-.625c-2.068-.5-3.074-1.2-3.074-2.149V6.547H22.6Z" fill="url(#attached-db-linear-gradient)" />
          <path d="M22.6,21.592c0,.951-1.006,1.654-3.074,2.15a28.033,28.033,0,0,1-6.273.628,28.315,28.315,0,0,1-6.279-.625c-2.068-.5-3.074-1.2-3.074-2.149V6.547H22.6Z" fill="url(#attached-db-linear-gradient-2)" />
          <path d="M3.9,6.678c0-.952,1.006-1.654,3.074-2.15A28.027,28.027,0,0,1,13.247,3.9a28.315,28.315,0,0,1,6.279.625c2.068.5,3.074,1.2,3.074,2.149s-1.006,1.653-3.074,2.149a28.028,28.028,0,0,1-6.273.629,28.375,28.375,0,0,1-6.279-.625C4.906,8.331,3.9,7.629,3.9,6.678Z" fill="url(#attached-db-linear-gradient-3)" />
          <path d="M22.6,11.039a5.293,5.293,0,0,1-2.417,1.253A30,30,0,0,1,6.316,12.3,5.283,5.283,0,0,1,3.9,11.043v1.765a5.284,5.284,0,0,0,2.416,1.254,30.012,30.012,0,0,0,13.867,0A5.283,5.283,0,0,0,22.6,12.8Z" opacity="0.15" style={{ mixBlendMode: "multiply" }} />
          <path d="M22.6,16.64a5.283,5.283,0,0,1-2.417,1.253A30,30,0,0,1,6.316,17.9,5.284,5.284,0,0,1,3.9,16.645v1.764a5.283,5.283,0,0,0,2.416,1.255,30,30,0,0,0,13.867-.006A5.283,5.283,0,0,0,22.6,18.4Z" opacity="0.15" style={{ mixBlendMode: "multiply" }} />
        </g>
        <rect x="17.5" y="17.5" width="13.6" height="13.6" rx="1.7" fill="url(#attached-db-linear-gradient-4)" />
        <polygon points="22.317 20.772 22.317 21.878 25.941 21.878 20.935 26.884 21.716 27.666 26.722 22.659 26.722 26.283 27.828 26.283 27.828 20.772 22.317 20.772" fill="#fff" />
      </g>
    </g>
  </svg>

);

const NetworkSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35">
    <path d="M16.977,15.617h1.046v3.662H16.977Zm1.033,5.44.549-.889L21.7,22.1l-.55.889ZM13.3,22.1l3.139-1.936.549.889-3.138,1.936Z" fill="#005ba1" />
    <polygon points="21.881 6.882 21.908 11.915 17.487 14.472 17.513 9.412 21.881 6.882" fill="#0078d4" />
    <polygon points="21.881 6.855 17.513 9.412 13.119 6.855 17.487 4.325 21.881 6.855" fill="#83b9f9" />
    <polygon points="17.513 9.412 17.487 14.472 13.092 11.915 13.092 6.855 17.513 9.412" fill="#5ea0ef" />
    <polygon points="17.513 9.385 17.487 9.412 17.487 14.472 17.487 14.472 21.881 11.915 17.513 9.385" fill="#5ea0ef" opacity="0.2" style={{ isolation: "isolate" }} />
    <polygon points="17.46 9.465 17.487 9.465 17.487 14.525 17.487 14.525 13.092 11.995 17.46 9.465" fill="#83b9f9" opacity="0.2" style={{ isolation: "isolate" }} />
    <polygon points="12.364 23.032 12.391 28.065 7.97 30.622 7.997 25.562 12.364 23.032" fill="#0078d4" />
    <polygon points="12.364 23.005 7.997 25.562 3.602 23.005 7.97 20.475 12.364 23.005" fill="#83b9f9" />
    <polygon points="7.997 25.562 7.97 30.622 3.576 28.065 3.576 23.005 7.997 25.562" fill="#5ea0ef" />
    <polygon points="7.997 25.535 7.97 25.562 7.97 30.622 7.97 30.622 12.364 28.065 7.997 25.535" fill="#5ea0ef" opacity="0.2" style={{ isolation: "isolate" }} />
    <polygon points="7.943 25.615 7.97 25.615 7.97 30.675 7.97 30.675 3.576 28.145 7.943 25.615" fill="#83b9f9" opacity="0.2" style={{ isolation: "isolate" }} />
    <polygon points="31.398 23.032 31.424 28.065 27.003 30.622 27.03 25.562 31.398 23.032" fill="#0078d4" />
    <polygon points="31.398 23.005 27.03 25.562 22.636 23.005 27.003 20.475 31.398 23.005" fill="#83b9f9" />
    <polygon points="27.03 25.562 27.003 30.622 22.609 28.065 22.609 23.005 27.03 25.562" fill="#5ea0ef" />
    <polygon points="27.03 25.535 27.003 25.562 27.003 30.622 27.003 30.622 31.398 28.065 27.03 25.535" fill="#5ea0ef" opacity="0.2" style={{ isolation: "isolate" }} />
    <polygon points="26.977 25.615 27.003 25.615 27.003 30.675 27.003 30.675 22.609 28.145 26.977 25.615" fill="#83b9f9" opacity="0.2" style={{ isolation: "isolate" }} />
  </svg>
);

const NetworkWatermarkSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" style={{ width: "100px", height: "100px", opacity: 0.5 }}>
    <path d="M16.977,15.617h1.046v3.662H16.977Zm1.033,5.44.549-.889L21.7,22.1l-.55.889ZM13.3,22.1l3.139-1.936.549.889-3.138,1.936Z" fill="#005ba1" />
    <polygon points="21.881 6.882 21.908 11.915 17.487 14.472 17.513 9.412 21.881 6.882" fill="#0078d4" />
    <polygon points="21.881 6.855 17.513 9.412 13.119 6.855 17.487 4.325 21.881 6.855" fill="#83b9f9" />
    <polygon points="17.513 9.412 17.487 14.472 13.092 11.915 13.092 6.855 17.513 9.412" fill="#5ea0ef" />
    <polygon points="17.513 9.385 17.487 9.412 17.487 14.472 17.487 14.472 21.881 11.915 17.513 9.385" fill="#5ea0ef" opacity="0.2" style={{ isolation: "isolate" }} />
    <polygon points="17.46 9.465 17.487 9.465 17.487 14.525 17.487 14.525 13.092 11.995 17.46 9.465" fill="#83b9f9" opacity="0.2" style={{ isolation: "isolate" }} />
    <polygon points="12.364 23.032 12.391 28.065 7.97 30.622 7.997 25.562 12.364 23.032" fill="#0078d4" />
    <polygon points="12.364 23.005 7.997 25.562 3.602 23.005 7.97 20.475 12.364 23.005" fill="#83b9f9" />
    <polygon points="7.997 25.562 7.97 30.622 3.576 28.065 3.576 23.005 7.997 25.562" fill="#5ea0ef" />
    <polygon points="7.997 25.535 7.97 25.562 7.97 30.622 7.97 30.622 12.364 28.065 7.997 25.535" fill="#5ea0ef" opacity="0.2" style={{ isolation: "isolate" }} />
    <polygon points="7.943 25.615 7.97 25.615 7.97 30.675 7.97 30.675 3.576 28.145 7.943 25.615" fill="#83b9f9" opacity="0.2" style={{ isolation: "isolate" }} />
    <polygon points="31.398 23.032 31.424 28.065 27.003 30.622 27.03 25.562 31.398 23.032" fill="#0078d4" />
    <polygon points="31.398 23.005 27.03 25.562 22.636 23.005 27.003 20.475 31.398 23.005" fill="#83b9f9" />
    <polygon points="27.03 25.562 27.003 30.622 22.609 28.065 22.609 23.005 27.03 25.562" fill="#5ea0ef" />
    <polygon points="27.03 25.535 27.003 25.562 27.003 30.622 27.003 30.622 31.398 28.065 27.03 25.535" fill="#5ea0ef" opacity="0.2" style={{ isolation: "isolate" }} />
    <polygon points="26.977 25.615 27.003 25.615 27.003 30.675 27.003 30.675 22.609 28.145 26.977 25.615" fill="#83b9f9" opacity="0.2" style={{ isolation: "isolate" }} />
  </svg>
);

const InProgressSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1000 1000" fill="#898989" enableBackground="new 0 0 1000 1000" style={{ width: "150px", height: "150px", opacity: 0.5 }}>
    <g>
      <g transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)">
        <path d="M4790.6,4517.5c-168.1-31.8-413.5-168.1-561.2-309c-125-118.1-197.7-236.3-699.8-1120.1c-309-543-1183.8-2072.1-1942.6-3396.8C828.1-1633,189.6-2764.6,169.2-2823.6c-104.5-311.3-90.9-590.7,43.2-877c150-315.8,461.2-543,817.9-595.3c222.7-31.8,7763.7-29.5,7963.7,2.3c424.9,65.9,774.8,393.1,874.7,817.9c70.4,297.7,25,536.2-165.8,881.6C9596-2398.7,8001,391.4,6183.3,3565.5c-334,581.7-445.3,720.3-665.7,838.4C5283.6,4528.8,5042.8,4567.5,4790.6,4517.5z M5245,3929c43.2-22.7,106.8-70.4,140.9-106.8c34.1-34.1,538.5-897.5,1122.4-1915.4C7089.9,889,7951-615.2,8421.4-1433.1c468.1-818,870.2-1529.1,892.9-1579.1c47.7-102.2,54.5-274.9,18.2-406.7c-34.1-127.2-229.5-313.5-361.3-349.9c-79.5-22.7-967.9-27.3-4010.2-22.7l-3908,6.8l-106.8,52.3c-136.3,68.2-254.5,202.2-290.8,336.3c-34.1,122.7-18.2,315.8,34.1,420.3c43.2,84.1,2651.5,4651,3405.9,5959.7c493,854.3,520.3,890.7,745.2,970.2C4979.1,4004,5115.5,3994.9,5245,3929z" />
        <path d="M3729.5,1747.8c-234-93.2-393.1-311.3-411.2-570.3c-15.9-215.8,38.6-361.3,186.3-508.9c138.6-138.6,274.9-193.1,488.5-193.1c447.6,0,754.3,443.1,608.9,877C4483.8,1695.6,4072.6,1881.9,3729.5,1747.8z" />
        <path d="M5949.3,1141.2c-579.4-56.8-972.5-136.3-1140.6-227.2c-147.7-81.8-302.2-254.5-345.4-388.5c-38.6-122.7-286.3-1604.1-286.3-1715.4c0-97.7,54.5-170.4,161.3-218.1l88.6-40.9l-147.7-115.9c-79.5-65.9-150-118.2-154.5-118.2c-6.8,0-54.5,56.8-106.8,125c-52.3,68.2-104.5,125-111.3,125c-9.1,0-97.7-59.1-195.4-134.1l-177.2-131.8l-150,9.1c-140.9,9.1-161.3,4.5-347.6-90.9c-138.6-72.7-236.3-106.8-336.3-118.2c-170.4-20.5-238.6-72.7-338.5-261.3c-113.6-213.6-186.3-284-368.1-352.2c-268.1-102.2-345.4-215.8-381.7-558.9l-15.9-156.8h1710.9c940.6,0,1710.9,6.8,1710.9,13.6c0,47.7-81.8,279.5-113.6,327.2c-22.7,31.8-77.2,134-122.7,227.2c-118.2,243.1-175,293.1-434,386.3l-65.9,25l72.7,56.8c40.9,31.8,72.7,68.2,72.7,79.5c0,11.4-45.4,79.5-102.2,150c-54.5,72.7-93.2,136.3-84.1,145.4c9.1,6.8,279.5,224.9,602.1,486.2l588.5,470.3l63.6-61.3l65.9-63.6l-284-309c-156.8-170.4-302.2-338.5-322.6-377.1c-59.1-106.8-50-361.3,15.9-488.5c29.5-56.8,70.4-122.7,93.2-147.7c22.7-25,181.8-304.5,354.4-622.6c336.3-615.7,372.6-661.2,531.7-661.2c43.2,0,104.5,13.6,136.3,29.5c72.7,36.4,159.1,165.9,159.1,238.6c0,31.8-138.6,331.7-306.7,665.7c-406.7,811.1-406.7,797.5,13.6,1122.4c138.6,106.8,259,193.1,268.1,193.1c9.1,0,38.6-213.6,68.2-474.9c47.7-440.8,61.3-515.8,197.7-983.8c81.8-279.5,165.9-531.7,188.6-563.5c59.1-84.1,181.8-159,254.5-159c38.6,0,93.2,25,138.6,65.9c65.9,59.1,75,79.5,81.8,220.4c9.1,143.1-4.5,195.4-140.9,615.7c-170.4,518-170.4,527.1-125,1133.8c20.4,254.5,20.4,384,2.3,511.2c-43.2,274.9-65.9,331.7-211.3,490.8L6540.1-338l68.2,77.2C6853.6,21,6967.2,714,6805.9,957.1c-29.5,43.2-102.2,102.2-172.7,138.6c-113.6,56.8-143.1,61.4-363.5,56.8C6137.9,1152.5,5992.5,1145.7,5949.3,1141.2z M6353.8,584.5c-6.8-15.9-45.4-129.5-84.1-249.9c-40.9-122.7-81.8-222.7-90.9-222.7c-11.4,0-104.5,88.6-209,197.7l-188.6,197.7L5997,555C6251.5,616.3,6367.4,623.1,6353.8,584.5z M5095-522c111.3-111.3,195.4-211.3,188.6-222.7c-22.7-36.3-583.9-486.2-583.9-468c0,11.4,36.4,206.7,79.5,438.5c43.2,231.8,79.5,427.2,79.5,438.5C4858.7-294.8,4906.4-333.4,5095-522z" />
      </g>
    </g>
  </svg>
);

const CloudErrorSvg = (
  <svg viewBox="0 0 113.386 113.773" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" style={{ width: "150px", height: "150px", opacity: 0.5 }}>
    <g>
      <path fill="#aab3bd" d="M113 57.63a13.117 13.117 0 0 0-13.108-13.108H98.31a31.58 31.58 0 0 0 1.13-9.266 34.763 34.763 0 0 0-67.8-11.3 22.014 22.014 0 0 0-7.684-1.356A24.016 24.016 0 0 0 0 46.677v.1a23.777 23.777 0 0 0 23.6 23.96h77.2A13.254 13.254 0 0 0 113 57.63" />
      <path d="M36.612 70.738a24.168 24.168 0 0 1-6.554-11.752 23.792 23.792 0 0 1 25.764-29.154 35.3 35.3 0 0 1 19.436-28.25A40.2 40.2 0 0 0 64.636 0a34.609 34.609 0 0 0-33 23.956 22 22 0 0 0-7.68-1.356A24.016 24.016 0 0 0 0 46.677v.1a23.777 23.777 0 0 0 23.6 23.96h13.012z" opacity=".2" />
      <path fill="#d0d5da" d="M86.1 101.246a11.752 11.752 0 1 1-23.5.434v-.434c0-6.554 11.752-28.7 11.752-28.7S86.1 94.694 86.1 101.246z" />
      <path d="M68.93 104.864C67.8 99.214 71.868 82.716 74.58 73a.7.7 0 0 1-.226-.452S62.6 94.694 62.6 101.246A11.812 11.812 0 0 0 73.45 113a15.308 15.308 0 0 1-4.52-8.136z" opacity=".3" />
    </g>
  </svg>
);

const BackupsSvg = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.6" d="M3.75439 2.98291H16.8687V12.436C16.8687 12.5014 16.8558 12.5662 16.8307 12.6267C16.8057 12.6872 16.769 12.7421 16.7227 12.7884C16.6764 12.8347 16.6215 12.8714 16.561 12.8964C16.5006 12.9214 16.4358 12.9343 16.3703 12.9343H4.25274C4.18729 12.9343 4.12249 12.9214 4.06203 12.8964C4.00157 12.8714 3.94663 12.8347 3.90036 12.7884C3.85408 12.7421 3.81737 12.6872 3.79233 12.6267C3.76728 12.5662 3.75439 12.5014 3.75439 12.436V2.98291Z" fill="#5EA0EF" />
    <path d="M4.25274 1.5686H16.3703C16.5025 1.5686 16.6293 1.62111 16.7227 1.71456C16.8162 1.80802 16.8687 1.93478 16.8687 2.06695V2.98289H3.75439V2.05718C3.75695 1.92671 3.81058 1.80245 3.90377 1.71109C3.99695 1.61974 4.12224 1.56858 4.25274 1.5686Z" fill="#005BA1" />
    <path d="M1.13135 6.47998H14.2456V15.9331C14.2456 15.9985 14.2327 16.0633 14.2077 16.1238C14.1827 16.1842 14.1459 16.2392 14.0997 16.2854C14.0534 16.3317 13.9985 16.3684 13.938 16.3935C13.8775 16.4185 13.8127 16.4314 13.7473 16.4314H1.62969C1.56425 16.4314 1.49944 16.4185 1.43898 16.3935C1.37852 16.3684 1.32358 16.3317 1.27731 16.2854C1.23103 16.2392 1.19433 16.1842 1.16928 16.1238C1.14424 16.0633 1.13135 15.9985 1.13135 15.9331V6.47998Z" fill="url(#paint0_linear_3172_27920)" />
    <path d="M1.62969 5.06567H13.7473C13.8795 5.06567 14.0062 5.11818 14.0997 5.21164C14.1931 5.30509 14.2456 5.43185 14.2456 5.56402V6.47996H1.13135V5.55425C1.13391 5.42378 1.18754 5.29952 1.28072 5.20816C1.3739 5.11681 1.4992 5.06565 1.62969 5.06567Z" fill="#198AB3" />
    <path d="M5.97081 10.6833L5.42001 11.2341C5.46732 10.7469 5.67005 10.2878 5.99826 9.92464C6.32647 9.56147 6.76277 9.31347 7.24272 9.21726C7.72268 9.12105 8.22086 9.18173 8.66369 9.39034C9.10651 9.59895 9.47052 9.94443 9.70196 10.3758L10.1648 9.91549C9.8394 9.39356 9.35706 8.9881 8.78695 8.75726C8.21685 8.52642 7.58829 8.48206 6.99142 8.63055C6.39455 8.77904 5.86004 9.11275 5.46456 9.5838C5.06908 10.0549 4.83294 10.6391 4.79001 11.2526L4.2171 10.6807L3.77173 11.1261L5.09344 12.453L6.41773 11.1287L5.97081 10.6833Z" fill="white" />
    <path d="M8.9609 11.7847L9.40627 12.2301L9.95707 11.6793C9.90977 12.1665 9.70704 12.6256 9.37883 12.9888C9.05062 13.352 8.61432 13.6 8.13436 13.6962C7.6544 13.7924 7.15623 13.7317 6.7134 13.5231C6.27057 13.3145 5.90656 12.969 5.67513 12.5376L5.21484 12.9979C5.54025 13.5199 6.0226 13.9253 6.5927 14.1562C7.1628 14.387 7.79137 14.4314 8.38824 14.2829C8.98511 14.1344 9.51961 13.8007 9.9151 13.3296C10.3106 12.8586 10.5467 12.2744 10.5896 11.6608L11.16 12.2327L11.6054 11.7873L10.2857 10.4604L8.9609 11.7847Z" fill="white" />
    <defs>
      <linearGradient id="paint0_linear_3172_27920" x1="7.68849" y1="16.4314" x2="7.68849" y2="6.48204" gradientUnits="userSpaceOnUse">
        <stop stopColor="#32BEDD" />
        <stop offset="0.18" stopColor="#32CAEA" />
        <stop offset="0.41" stopColor="#32D2F2" />
        <stop offset="0.78" stopColor="#32D4F5" />
      </linearGradient>
    </defs>
  </svg>
);

const SupportSvg = (
  <svg viewBox="0 0 35 35" width="35" height="35" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <symbol viewBox="0 0 18 18" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="support" data-type="200">
        <defs>
          <linearGradient id="da9ee395-deae-4a83-8248-9e03beb51014" x1="7.434" x2="9.215" y1="1.303" y2="23.449" gradientUnits="userSpaceOnUse">
            <stop offset=".225" stopColor="#32d4f5" />
            <stop offset=".389" stopColor="#30cff1" />
            <stop offset=".584" stopColor="#2bc0e4" />
            <stop offset=".795" stopColor="#23a9ce" />
            <stop offset="1" stopColor="#198ab3" />
          </linearGradient>
        </defs>
        <g>
          <title />
          <path fill="url(#da9ee395-deae-4a83-8248-9e03beb51014)" d="M15.945 16.554c-.417-3.333-2.051-6.156-5.062-7.071a4.079 4.079 0 1 0-4.462-.035c-3.034.814-4.653 3.37-5.023 7.116a1.3 1.3 0 0 0 1.161 1.429A1.15 1.15 0 0 0 2.69 18h11.965a1.294 1.294 0 0 0 1.3-1.29 1.347 1.347 0 0 0-.01-.156z" />
          <path d="M8.684 10.135a4.068 4.068 0 0 1-2.211-.651L8.662 15.2l2.173-5.681a4.063 4.063 0 0 1-2.151.616z" opacity=".8" fill="#fff" />
          <path fill="#767676" d="M14.805 7.227a6.39 6.39 0 0 0-.092-2.543A6.207 6.207 0 0 0 8.888.008a5.543 5.543 0 0 0-5.212 2.764.588.588 0 0 0 .187.812.543.543 0 0 0 .737-.164 4.515 4.515 0 0 1 4.223-2.285 5.078 5.078 0 0 1 4.758 3.679 5.242 5.242 0 0 1 .126 2.137.936.936 0 0 0-.536.589l-.273.9a.94.94 0 1 0 1.8.547l.274-.9a.938.938 0 0 0-.167-.86z" />
        </g>
      </symbol>
    </defs>
    <use href="#support" />
  </svg>
);

const SupportWatermarkSvg = (
  <svg viewBox="0 0 35 35" width="35" height="35" xmlns="http://www.w3.org/2000/svg" style={{ width: "100px", height: "100px", opacity: 0.5 }}>
    <defs>
      <symbol viewBox="0 0 18 18" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="support" data-type="200">
        <defs>
          <linearGradient id="da9ee395-deae-4a83-8248-9e03beb51014" x1="7.434" x2="9.215" y1="1.303" y2="23.449" gradientUnits="userSpaceOnUse">
            <stop offset=".225" stopColor="#32d4f5" />
            <stop offset=".389" stopColor="#30cff1" />
            <stop offset=".584" stopColor="#2bc0e4" />
            <stop offset=".795" stopColor="#23a9ce" />
            <stop offset="1" stopColor="#198ab3" />
          </linearGradient>
        </defs>
        <g>
          <title />
          <path fill="url(#da9ee395-deae-4a83-8248-9e03beb51014)" d="M15.945 16.554c-.417-3.333-2.051-6.156-5.062-7.071a4.079 4.079 0 1 0-4.462-.035c-3.034.814-4.653 3.37-5.023 7.116a1.3 1.3 0 0 0 1.161 1.429A1.15 1.15 0 0 0 2.69 18h11.965a1.294 1.294 0 0 0 1.3-1.29 1.347 1.347 0 0 0-.01-.156z" />
          <path d="M8.684 10.135a4.068 4.068 0 0 1-2.211-.651L8.662 15.2l2.173-5.681a4.063 4.063 0 0 1-2.151.616z" opacity=".8" fill="#fff" />
          <path fill="#767676" d="M14.805 7.227a6.39 6.39 0 0 0-.092-2.543A6.207 6.207 0 0 0 8.888.008a5.543 5.543 0 0 0-5.212 2.764.588.588 0 0 0 .187.812.543.543 0 0 0 .737-.164 4.515 4.515 0 0 1 4.223-2.285 5.078 5.078 0 0 1 4.758 3.679 5.242 5.242 0 0 1 .126 2.137.936.936 0 0 0-.536.589l-.273.9a.94.94 0 1 0 1.8.547l.274-.9a.938.938 0 0 0-.167-.86z" />
        </g>
      </symbol>
    </defs>
    <use href="#support" />
  </svg>
);

const SupportSmallSvg = (
  <svg viewBox="0 0 18 18" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <symbol viewBox="0 0 18 18" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="support" data-type="200">
        <defs>
          <linearGradient id="da9ee395-deae-4a83-8248-9e03beb51014" x1="7.434" x2="9.215" y1="1.303" y2="23.449" gradientUnits="userSpaceOnUse">
            <stop offset=".225" stopColor="#32d4f5" />
            <stop offset=".389" stopColor="#30cff1" />
            <stop offset=".584" stopColor="#2bc0e4" />
            <stop offset=".795" stopColor="#23a9ce" />
            <stop offset="1" stopColor="#198ab3" />
          </linearGradient>
        </defs>
        <g>
          <title />
          <path fill="url(#da9ee395-deae-4a83-8248-9e03beb51014)" d="M15.945 16.554c-.417-3.333-2.051-6.156-5.062-7.071a4.079 4.079 0 1 0-4.462-.035c-3.034.814-4.653 3.37-5.023 7.116a1.3 1.3 0 0 0 1.161 1.429A1.15 1.15 0 0 0 2.69 18h11.965a1.294 1.294 0 0 0 1.3-1.29 1.347 1.347 0 0 0-.01-.156z" />
          <path d="M8.684 10.135a4.068 4.068 0 0 1-2.211-.651L8.662 15.2l2.173-5.681a4.063 4.063 0 0 1-2.151.616z" opacity=".8" fill="#fff" />
          <path fill="#767676" d="M14.805 7.227a6.39 6.39 0 0 0-.092-2.543A6.207 6.207 0 0 0 8.888.008a5.543 5.543 0 0 0-5.212 2.764.588.588 0 0 0 .187.812.543.543 0 0 0 .737-.164 4.515 4.515 0 0 1 4.223-2.285 5.078 5.078 0 0 1 4.758 3.679 5.242 5.242 0 0 1 .126 2.137.936.936 0 0 0-.536.589l-.273.9a.94.94 0 1 0 1.8.547l.274-.9a.938.938 0 0 0-.167-.86z" />
        </g>
      </symbol>
    </defs>
    <use href="#support" />
  </svg>
);

const QuotasSvg = (
  <svg viewBox="0 0 35 35" width="35" height="35" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <symbol viewBox="0 0 18 18" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="quotas" data-type="196">
        <g>
          <rect width="2.494" height="18" x="7.753" y="5.476" fill="#5e9624" rx=".596" transform="rotate(-90 9 14.476)" />
          <rect width="2.494" height="18" x="7.753" y=".059" fill="#5e9624" rx=".596" transform="rotate(-90 9 9.059)" />
          <rect width="2.494" height="18" x="7.753" y="-5.444" fill="#5e9624" rx=".596" transform="rotate(-90 9 3.556)" />
          <rect width="2.494" height="11.838" x="10.834" y="8.557" fill="url(#da9ee395-deae-4a83-8248-9e03beb51043)" rx=".596" transform="rotate(-90 12.081 14.476)" />
          <rect width="2.494" height="3.744" x="14.881" y="7.187" fill="url(#da9ee395-deae-4a83-8248-9e03beb51044)" rx=".596" transform="rotate(-90 16.128 9.06)" />
          <rect width="2.494" height="11.838" x="10.834" y="-2.363" fill="url(#da9ee395-deae-4a83-8248-9e03beb51045)" rx=".596" transform="rotate(-90 12.081 3.556)" />
          <rect width="3.766" height="1.178" x="4.74" y="13.855" fill="#e6e6e6" rx=".589" transform="rotate(-90 6.623 14.444)" />
          <rect width="3.766" height="1.178" x="12.671" y="8.419" fill="#e6e6e6" rx=".589" transform="rotate(-90 14.554 9.008)" />
          <rect width="3.766" height="1.178" x="4.74" y="2.967" fill="#e6e6e6" rx=".589" transform="rotate(-90 6.623 3.556)" />
        </g>
      </symbol>
    </defs>
    <use href="#quotas" />
  </svg>
);

const SubscriptionsSvg = (
  <svg viewBox="0 0 35 35" width="35" height="35" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <symbol viewBox="0 0 18 18" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="subscriptions" data-type="34">
        <defs>
          <radialGradient id="sub-a" cx="-36.63" cy="17.12" r="11.18" gradientTransform="matrix(.94 0 0 .94 41.88 -7.4)" gradientUnits="userSpaceOnUse">
            <stop offset=".27" stopColor="#ffd70f" />
            <stop offset=".49" stopColor="#ffcb12" />
            <stop offset=".88" stopColor="#feac19" />
            <stop offset="1" stopColor="#fea11b" />
          </radialGradient>
        </defs>
        <path d="M13.56 7.19a2.07 2.07 0 000-2.93L10 .69a2.06 2.06 0 00-2.92 0L3.52 4.26a2.09 2.09 0 000 2.93l3 3a.61.61 0 01.17.41v5.52a.7.7 0 00.2.5l1.35 1.35a.45.45 0 00.66 0l1.31-1.31.77-.77a.26.26 0 000-.38l-.55-.56a.29.29 0 010-.42l.55-.56a.26.26 0 000-.38L10.4 13a.28.28 0 010-.41L11 12a.26.26 0 000-.38l-.77-.78v-.28zm-5-5.64a1.18 1.18 0 11-1.19 1.18 1.17 1.17 0 011.17-1.18z" fill="url(#sub-a)" />
        <path d="M7.62 16.21A.25.25 0 008 16v-4.45a.27.27 0 00-.11-.22.25.25 0 00-.39.22V16a.27.27 0 00.12.21z" fill="#ff9300" opacity=".75" />
        <rect x="5.69" y="5.45" width="5.86" height=".69" rx=".32" fill="#ff9300" opacity=".75" />
        <rect x="5.69" y="6.57" width="5.86" height=".69" rx=".32" fill="#ff9300" opacity=".75" />
      </symbol>
    </defs>
    <use href="#subscriptions" />
  </svg>
);

const FlyoutMenuSvg = (
  <svg viewBox="0 0 100 60" width="116" height="69" fill="white" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 60" role="presentation" focusable="false" id="FxSymbol0-012" data-type="1">
        <g>
          <title />
          <rect width="99" height="59" x=".5" y=".5" stroke="#D2D2D2" rx="3.5" className="msportalfx-svg-c01" />
          <path fill="#0078D4" d="M0 4a4 4 0 0 1 4-4h92a4 4 0 0 1 4 4v8H0V4z" />
          <path fill="#D2D2D2" d="M33 22h10v10H33zm0 12h10v3H33zm32-12h10v10H65zm0 12h10v3H65zm16-12h10v10H81zm0 12h10v3H81zM49 22h10v10H49zm0 12h10v3H49zm-16 8h58v3H33zm0 5h58v3H33z" />
          <path fill="#E2E2E2" d="M0 4a4 4 0 0 1 4-4h21v60H4a4 4 0 0 1-4-4V4z" />
          <path stroke="#787878" strokeLinecap="round" strokeWidth="2" d="m14 26 6 6.24L14.461 38" />
          <path stroke="#787878" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 32.25H8" />
        </g>
      </symbol>
    </defs>
    <use href="#FxSymbol0-012" />
  </svg>
);

const DockMenuSvg = (
  <svg viewBox="0 0 100 60" width="116" height="69" fill="white" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 60" className="" role="presentation" focusable="false" id="FxSymbol0-013" data-type="1">
        <g>
          <title />
          <rect width="99" height="59" x=".5" y=".5" stroke="#D2D2D2" rx="3.5" className="msportalfx-svg-c01" />
          <path fill="#D2D2D2" d="M0 4a4 4 0 0 1 4-4h17a4 4 0 0 1 4 4v56H4a4 4 0 0 1-4-4V4z" />
          <path fill="#0078D4" d="M0 4a4 4 0 0 1 4-4h92a4 4 0 0 1 4 4v8H0V4z" />
          <path fill="#D2D2D2" d="M33 22h10v10H33zm0 12h10v3H33zm32-12h10v10H65zm0 12h10v3H65zm16-12h10v10H81zm0 12h10v3H81zM49 22h10v10H49zm0 12h10v3H49zm-16 8h58v3H33zm0 5h58v3H33z" />
        </g>
      </symbol>
    </defs>
    <use href="#FxSymbol0-013" />
  </svg>
);

const NetworkingSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="18" height="18" aria-hidden="true" role="presentation" focusable="false">
    <defs>
      <linearGradient id="networkingGradientOne" x1="5.38" x2="5.355" y1="9.608" y2="6.409" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#ccc" />
        <stop offset=".123" stopColor="#d7d7d7" />
        <stop offset="1" stopColor="#fcfcfc" />
      </linearGradient>
      <linearGradient id="networkingGradientTwo" x1="10.013" x2="10.013" y1="12.807" y2="9.939" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#ccc" />
        <stop offset=".123" stopColor="#d7d7d7" />
        <stop offset="1" stopColor="#fcfcfc" />
      </linearGradient>
      <linearGradient id="networkingGradienThree" x1="13.281" x2="13.281" y1="9.34" y2="6.294" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#ccc" />
        <stop offset=".123" stopColor="#d7d7d7" />
        <stop offset="1" stopColor="#fcfcfc" />
      </linearGradient>
      <radialGradient id="networkingGradientFour" cx="53564.151" cy="5728.413" r="300.075" gradientTransform="matrix(.023 0 0 .023 -1216.531 -123.474)" gradientUnits="userSpaceOnUse">
        <stop offset=".183" stopColor="#5ea0ef" />
        <stop offset="1" stopColor="#0078d4" />
      </radialGradient>
    </defs>
    <path fill="#37c2b1" d="M0 16.294h18l-2.862-3.123a.612.612 0 0 0-.45-.2H3.779a.608.608 0 0 0-.418.166z" />
    <path fill="url(#networkingGradientFour)" d="M13.3 13.026A6.866 6.866 0 0 1 4.889 2.175l.069-.053a6.866 6.866 0 0 1 8.346 10.9" />
    <path d="M3.831 8.93a15.193 15.193 0 0 0-.676 2.119 7.572 7.572 0 0 0 .5.745 6.752 6.752 0 0 0 .448.523 14.327 14.327 0 0 1 .875-2.8 2.2 2.2 0 0 1-1.147-.587z" opacity=".6" fill="white" />
    <path fill="#f2f2f2" d="M4.622 5.266a9.645 9.645 0 0 1-.557-2.379 6.81 6.81 0 0 0-.89 1.178 10.82 10.82 0 0 0 .459 1.908 2.218 2.218 0 0 1 .988-.707z" opacity=".55" />
    <circle cx="5.362" cy="7.343" r="2.207" fill="url(#networkingGradientOne)" />
    <path fill="#f2f2f2" d="M8.579 11.373a1.426 1.426 0 0 1 .433-1.025 9.673 9.673 0 0 1-2.039-1.5 2.2 2.2 0 0 1-1.206.663 9.544 9.544 0 0 0 1.172 1.038 9.961 9.961 0 0 0 1.654 1.008 1.385 1.385 0 0 1-.014-.184zm5.088.171a9.6 9.6 0 0 1-2.224-.259v.088a1.428 1.428 0 0 1-.408 1 11.183 11.183 0 0 0 2.756.2 6.871 6.871 0 0 0 .929-1.085 9.824 9.824 0 0 1-1.053.056z" opacity=".55" />
    <circle cx="10.013" cy="11.373" r="1.434" fill="url(#networkingGradientTwo)" />
    <path fill="#f2f2f2" d="M9.63 4.448a10.951 10.951 0 0 1 4.8-1.169 6.765 6.765 0 0 0-1.2-1.167 11.64 11.64 0 0 0-3.792.9 9.895 9.895 0 0 0-.775.377 13.756 13.756 0 0 1-1.6-2.352 6.739 6.739 0 0 0-.88.338 14.4 14.4 0 0 0 1.666 2.5 10 10 0 0 0-1.707 1.406 2.2 2.2 0 0 1 1.088.891 9.569 9.569 0 0 1 1.559-1.246 22.172 22.172 0 0 0 2.988 2.616 1.49 1.49 0 0 1 .494-.8A21.416 21.416 0 0 1 9.63 4.448z" opacity=".7" />
    <circle cx="13.281" cy="7.817" r="1.523" fill="url(#networkingGradienThree)" />
    <path fill="#f2f2f2" d="m15.839 8.844-.259-.136-.025-.014-.239-.129-.044-.024-.216-.12-.056-.03-.254-.145a1.444 1.444 0 0 1-.514.747l.3.173.068.038.281.156.027.015q.341.186.7.368a6.616 6.616 0 0 0 .229-.9z" opacity=".55" />
    <circle cx="5.362" cy="7.343" r="2.207" fill="url(#networkingGradientOne)" />
    <circle cx="10.013" cy="11.373" r="1.434" fill="url(#networkingGradientTwo)" />
    <path fill="#42e8ca" d="M0 16.294h18v.362a.61.61 0 0 1-.61.61H.61a.61.61 0 0 1-.61-.61v-.362z" />
  </svg>
);

const ConnectSvg = (
  <svg viewBox="0 0 14.7 14.7" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.9 9.4A3.2 3.2 0 0 1 2.1 8a2.8 2.8 0 0 1 .8-1.1l1.7-1.8 5 5-1.8 1.7a2.8 2.8 0 0 1-1.1.8 3.1 3.1 0 0 1-1.3.3l-1.2-.2-.9-.5-2.6 2.5L0 14l2.5-2.6a4.1 4.1 0 0 1-.5-.9 4.5 4.5 0 0 1-.1-1.1zm3.5 2.5.9-.2a2.4 2.4 0 0 0 .8-.6l1.1-1-3.6-3.6-1 1.1-.6.8a3.1 3.1 0 0 0-.1 1 2.8 2.8 0 0 0 .1.9l.6.8.8.6zm6.8-8.6a4.1 4.1 0 0 1 .5.9 5 5 0 0 1 .2 1.2 3.1 3.1 0 0 1-.3 1.3 2.8 2.8 0 0 1-.8 1.1l-1.7 1.8-5-5 1.8-1.7A2.8 2.8 0 0 1 8 2.1a3.2 3.2 0 0 1 1.4-.2h1.1l.9.5L14 0l.7.7zm-1.1 3.8a2.4 2.4 0 0 0 .6-.8 2.9 2.9 0 0 0 .2-.9 3 3 0 0 0-.2-1l-.6-.8-.8-.5a1.5 1.5 0 0 0-.9-.2h-1l-.8.6-1.1 1 3.6 3.6z" fill="#015cda" />
  </svg>
);

const ConfigurationSvg = (
  <svg viewBox="0 0 18 18" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="configuration-gradient" x1="9" x2="9" y1="16.431" y2="4.559" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset=".156" stopColor="#1380da" />
        <stop offset=".528" stopColor="#3c91e5" />
        <stop offset=".822" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
    </defs>
    <path fill="#a3a3a3" d="M13.135 4.659h-.85V2.422a.1.1 0 0 0-.026 0H5.845a.093.093 0 0 0-.026 0v2.237h-.85v-2.28a.846.846 0 0 1 .876-.81h6.414a.846.846 0 0 1 .876.81z" />
    <rect width="17" height="11.872" x=".5" y="4.559" fill="url(#configuration-gradient)" rx=".567" />
    <path fill="#9cebff" d="M.5 7.594h17v1.311H.5z" />
    <path fill="#005ba1" d="M6.617 8.905H11.5v1.531a.281.281 0 0 1-.281.281H6.9a.281.281 0 0 1-.281-.281V8.905h-.002z" />
    <path fill="#83b9f9" d="M.5 10.894v2.995l4.644 1.489.871-2.716L.5 10.894z" />
    <path fill="#5ea0ef" d="M17.5 10.745a2.718 2.718 0 1 0 0 4.837z" />
  </svg>
);

const SecuritySvg = (
  <svg viewBox="0 0 18 18" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="security-gradient" x1="9" y1="18.64" x2="9" y2="2.139" gradientTransform="matrix(1 0 0 -1 0 20)" gradientUnits="userSpaceOnUse">
        <stop offset=".18" stopColor="#5ea0ef" />
        <stop offset="1" stopColor="#0078d4" />
      </linearGradient>
    </defs>
    <path d="M16.36 8.4c0 4.84-5.85 8.74-7.12 9.53a.46.46 0 0 1-.48 0c-1.27-.79-7.12-4.69-7.12-9.53V2.58a.46.46 0 0 1 .45-.46C6.64 2 5.59 0 9 0s2.36 2 6.91 2.12a.46.46 0 0 1 .45.46Z" fill="#0078d4" />
    <path d="M15.75 8.45c0 4.44-5.36 8-6.53 8.74a.429.429 0 0 1-.44 0c-1.17-.72-6.53-4.3-6.53-8.74V3.11a.42.42 0 0 1 .41-.42C6.83 2.58 5.87.75 9 .75s2.17 1.83 6.34 1.94a.42.42 0 0 1 .41.42Z" fill="url(#security-gradient)" />
  </svg>
);

const ManagementSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" role="presentation" focusable="false" viewBox="0 0 35 35">
    <defs>
      <linearGradient id="maintenance-gradient" x1="17.5" y1="31.1" x2="17.5" y2="3.9" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#0078d4" />
        <stop offset="0.16" stopColor="#1380da" />
        <stop offset="0.53" stopColor="#3c91e5" />
        <stop offset="0.82" stopColor="#559cec" />
        <stop offset="1" stopColor="#5ea0ef" />
      </linearGradient>
    </defs>
    <polygon points="27.7 8.405 27.7 31.1 7.3 31.1 7.3 3.9 23.195 3.9 27.7 8.405" fill="url(#maintenance-gradient)" />
    <polygon points="23.195 3.9 23.195 8.503 27.7 8.405 23.195 3.9" fill="#fff" opacity="0.5" />
    <path d="M15.781,15.324h8.28v1.195h-8.28Zm0,3.661h5.978v1.2H15.781Zm0,3.662H23.59v1.2H15.781Z" fill="#fff" />
    <circle cx="12.269" cy="15.921" r="0.915" fill="#fff" />
    <circle cx="12.269" cy="19.583" r="0.915" fill="#fff" />
    <circle cx="12.269" cy="23.244" r="0.915" fill="#fff" />
  </svg>
);

const DatabaseNodesSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35">
    <defs>
      <linearGradient id="dbnodes-linear-gradient" x1="10.7" y1="22.509" x2="10.7" y2="6.306" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="0.8" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="dbnodes-linear-gradient-2" x1="10.7" y1="22.509" x2="10.7" y2="6.306" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#1380da" />
        <stop offset="1" stopColor="#559cec" />
      </linearGradient>
      <linearGradient id="dbnodes-linear-gradient-3" x1="10.7" y1="8.947" x2="10.7" y2="3.9" xlinkHref="#dbnodes-linear-gradient-2" />
      <linearGradient id="dbnodes-linear-gradient-4" x1="24.3" y1="31.1" x2="24.3" y2="14.897" xlinkHref="#dbnodes-linear-gradient" />
      <linearGradient id="dbnodes-linear-gradient-5" x1="24.3" y1="31.1" x2="24.3" y2="14.897" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b3b3" />
        <stop offset="1" stopColor="#e6e6e6" />
      </linearGradient>
      <linearGradient id="dbnodes-linear-gradient-6" x1="24.3" y1="17.538" x2="24.3" y2="12.491" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#b3b4b4" />
        <stop offset="0.33" stopColor="#b3b4b4" />
        <stop offset="0.82" stopColor="#cccccb" />
        <stop offset="1" stopColor="#cccccb" />
      </linearGradient>
    </defs>
    <g style={{ isolation: "isolate" }}>
      <g>
        <g>
          <path d="M19.2,19.984c0,.865-.914,1.5-2.795,1.954a25.488,25.488,0,0,1-5.7.571A25.745,25.745,0,0,1,5,21.941C3.114,21.49,2.2,20.852,2.2,19.987V6.306h17Z" fill="url(#dbnodes-linear-gradient-4)" />
          <path d="M19.2,19.984c0,.865-.914,1.5-2.795,1.954a25.488,25.488,0,0,1-5.7.571A25.745,25.745,0,0,1,5,21.941C3.114,21.49,2.2,20.852,2.2,19.987V6.306h17Z" fill="url(#dbnodes-linear-gradient-5)" />
          <path d="M2.2,6.425c0-.865.914-1.5,2.8-1.954A25.488,25.488,0,0,1,10.7,3.9a25.745,25.745,0,0,1,5.707.568c1.881.451,2.795,1.089,2.795,1.954s-.914,1.5-2.795,1.954a25.488,25.488,0,0,1-5.7.571A25.745,25.745,0,0,1,5,8.379C3.114,7.928,2.2,7.29,2.2,6.425Z" fill="url(#dbnodes-linear-gradient-6)" />
          <path d="M19.2,10.39A4.81,4.81,0,0,1,17,11.529a27.267,27.267,0,0,1-12.6.005,4.786,4.786,0,0,1-2.2-1.14V12a4.8,4.8,0,0,0,2.2,1.141A27.28,27.28,0,0,0,17,13.133a4.8,4.8,0,0,0,2.2-1.139Z" opacity="0.15" style={{ mixBlendMode: "multiply" }} />
          <path d="M19.2,15.482A4.81,4.81,0,0,1,17,16.621a27.28,27.28,0,0,1-12.6.006,4.8,4.8,0,0,1-2.2-1.141v1.6a4.8,4.8,0,0,0,2.2,1.141A27.28,27.28,0,0,0,17,18.225a4.8,4.8,0,0,0,2.2-1.139Z" opacity="0.15" style={{ mixBlendMode: "multiply" }} />
        </g>
        <g>
          <path d="M32.8,28.575c0,.865-.914,1.5-2.795,1.954a25.488,25.488,0,0,1-5.7.571,25.745,25.745,0,0,1-5.707-.568c-1.881-.451-2.795-1.089-2.795-1.954V14.9h17Z" fill="url(#dbnodes-linear-gradient-4)" />
          <path d="M32.8,28.575c0,.865-.914,1.5-2.795,1.954a25.488,25.488,0,0,1-5.7.571,25.745,25.745,0,0,1-5.707-.568c-1.881-.451-2.795-1.089-2.795-1.954V14.9h17Z" fill="url(#dbnodes-linear-gradient-5)" />
          <path d="M15.8,15.016c0-.865.914-1.5,2.795-1.954a25.488,25.488,0,0,1,5.7-.571,25.745,25.745,0,0,1,5.707.568c1.881.451,2.795,1.089,2.795,1.954s-.914,1.5-2.795,1.954a25.488,25.488,0,0,1-5.7.571A25.745,25.745,0,0,1,18.6,16.97C16.714,16.519,15.8,15.881,15.8,15.016Z" fill="url(#dbnodes-linear-gradient-6)" />
          <path d="M32.8,18.981a4.81,4.81,0,0,1-2.2,1.139,27.28,27.28,0,0,1-12.6.006,4.8,4.8,0,0,1-2.2-1.141v1.6A4.8,4.8,0,0,0,18,21.73,27.28,27.28,0,0,0,30.6,21.724a4.8,4.8,0,0,0,2.2-1.139Z" opacity="0.15" style={{ mixBlendMode: "multiply" }} />
          <path d="M32.8,24.073a4.81,4.81,0,0,1-2.2,1.139,27.28,27.28,0,0,1-12.6.006,4.8,4.8,0,0,1-2.2-1.141v1.6A4.8,4.8,0,0,0,18,26.822,27.28,27.28,0,0,0,30.6,26.816a4.8,4.8,0,0,0,2.2-1.139Z" opacity="0.15" style={{ mixBlendMode: "multiply" }} />
        </g>
      </g>
    </g>
  </svg>
);

registerIcons({
  icons: {
    "apex-svg": ApexSvg,
    "apex-watermark-svg": ApexWatermarkSvg,
    "cloud-error-svg": CloudErrorSvg,
    "in-progress-svg": InProgressSvg,
    "activity-svg": Activity,
    "adb-svg": AutonomousDatabaseSvg,
    "adb-watermark-svg": AutonomousDatabaseWatermarkSvg,
    "add-svg": AddSvg,
    "allServices-svg": AllServices,
    "appServices-svg": AppServices,
    "base-database-svg": BaseDatabaseSvg,
    "base-database-watermark-svg": BaseDatabaseWatermarkSvg,
    "billing-svg": Billing,
    "dashboard-svg": Dashboard,
    "database-svg": DatabaseHomeSvg,
    "deployment-svg": DeploymentSvg,
    "deployment-detail-svg": DeploymentDetailSvg,
    "deployment-meta-svg": DeploymentMetaIconSvg,
    "deployment-watermark-svg": DeploymentWatermarkSvg,
    "exa-watermark-svg": ExadataWatermarkSvg,
    "exa-svg": ExadataOracleCloudSvg,
    "exadata-svg": ExadataSvg,
    "functionApp-svg": FunctionApp,
    "heatwave-svg": HeatWave,
    "help-svg": HelpSvg,
    "homeSolid-svg": HomeSolid,
    "infra-svg": InfrastructureSvg,
    "infra-watermark-svg": InfrastructureWatermarkSvg,
    "mysql-svg": MysqlSvg,
    "mysql-watermark-svg": MySQLWatermarkSvg,
    "pluggable-svg": DatabaseSvg,
    "quickStart-svg": Quickstart,
    "resources-svg": Resources,
    "resourceGroup-svg": ResourceGroup,
    "sqlDatabase-svg": SQLDatabase,
    "subscription-svg": SubscriptionsSvg,
    "tags-svg": Tags,
    "tagEnabled-svg": TagEnabled,
    "tagDisabled-svg": TagDisabled,
    "vmcluster-svg": VmClusterNewSvg,
    "vmcluster-watermark-svg": VmClusterWatermarkNewSvg,
    "dbSystem-svg": DbSystemSvg,
    "attachedDb-svg": AttachedDatabaseSvg,
    "network-svg": NetworkSvg,
    "networking-svg": NetworkingSvg,
    "network-watermark-svg": NetworkWatermarkSvg,
    "connect-svg": ConnectSvg,
    "configuration-svg": ConfigurationSvg,
    "security-svg": SecuritySvg,
    "management-svg": ManagementSvg,
    "databaseNodes-svg": DatabaseNodesSvg,
    "backups-svg": BackupsSvg,
    "support-svg": SupportSvg,
    "support-small-svg": SupportSmallSvg,
    "support-watermark-svg": SupportWatermarkSvg,
    "quotas-svg": QuotasSvg,
    "flyout-menu-svg": FlyoutMenuSvg,
    "dock-menu-svg": DockMenuSvg,
    "delete-Svg": DeleteIconSvg,
    "punch-out-link-svg": punchOutIconSvg,
  },
});
